import React from "react";
import moment from "moment";
import Select from "react-select";
import { v4 as uuidv4 } from "uuid";
import {
  Card,
  Col,
  Row,
  Table,
  CardHeader,
  CardBody,
  Button,
  UncontrolledCollapse,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  CustomInput,
  Tooltip,
} from "reactstrap";
import Page from "../components/Page";
import {
  BsDashCircle,
  BsPlusCircle,
  BsCheck,
  BsExclamationTriangleFill,
} from "react-icons/bs";
import {
  IoMdMailOpen,
  IoIosEye,
  IoMdFlag,
  IoMdNotifications,
} from "react-icons/io";
import { GoCreditCard } from "react-icons/go";
import { HiOutlineReceiptRefund } from "react-icons/hi";
import { MdEdit, MdClose } from "react-icons/md";
import { ImCheckmark, ImCross } from "react-icons/im";

import config from "../config/local";
import * as Server from "../Server";
import PageSpinner from "../components/PageSpinner";
import NotificationSystem from "react-notification-system";
import { capitalizeFirstLetter } from "../GeneralFunctions";
import { NOTIFICATION_SYSTEM_STYLE } from "../utils/constants";
var cloneDeep = require("lodash.clonedeep");

// function monthDiff(date1, date2) {
//   var months;
//   months = (date2.getFullYear() - date1.getFullYear()) * 12;
//   months -= date1.getMonth();
//   months += date2.getMonth();
//   return months <= 0 ? 0 : months - 1;
// }

class PlayerPaymentDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      camp: {},
      playerName: "",
      username: "",
      transaction: {},
      isOpen: false,
      confirmationModal: false,
      cancelSubscription: false,
      addInstallmentModal: false,
      refundAmount: 0,
      selectedId: "",
      paymentConfirmationModal: false,
      cashPaymentConfirmationModal: false,
      tempInstallmentsCreatedPlans: [],
      showFields: false,
      price: 0,
      maxPrice: 0,
      fullPayment: true,
      id: "",
      refundConfirmationModal: false,
      reprocessConfirmationModal: false,
      reprocessTransactions: [],
      reprocessDataConfirmationModal: false,
      reprocessTransactionData: [],
      reprocessTransactionDate: "",
      updateReprocessDate: false,
      reprocessTransactionId: "",
      reprocessTransactionPaymentType: "",
      subscriptionUpdateModal: false,
      subscriptionDate: "",
      subscription: {},
      refundProcessingFees: false,
      processingFee: 0,
      totalPrice: 0,
      installment: {},
      installmentUpdateModal: false,
      installmentDate: "",
      subscriptionSelectedIndex: null,
      subscriptionCashPaymentTooltip: false,
      subscriptionTransactionEditTooltip: false,
      subscriptionRefundTooltip: false,
      subscriptionFailedCashPaymentTooltip: false,
      subscriptionReprocessTooltip: false,
      subscriptionViewReprocessTooltip: false,

      installmentSelectedIndex: null,
      installmentCashPaymentTooltip: false,
      installmentTransactionEditTooltip: false,
      installmentRefundTooltip: false,
      installmentFailedCashPaymentTooltip: false,
      installmentReprocessTooltip: false,
      installmentViewReprocessTooltip: false,
      options: [
        { label: "Cash", value: "cash" },
        { label: "Injured", value: "injured" },
        { label: "Break", value: "break" },
        { label: "Waived", value: "waived" },
        { label: "Scholarship", value: "scholarship" },
        { label: "Other", value: "other" },
      ],
      selectedOption: {},
      optionNote: "",
      resumePaymentDate: "",
      stripeCards: [],
      allCreditCardOptions: [],
      selectedCreditCard: null,
      selectedCreditCardForPayment: {},
      updateCreditCardModal: false,
      disputeResolveModal: false,
      disputeTransactionId: "",
      disputeId: "",
      disputeResolvedNote: "",
      disputeTooltip: false,
      disputeSelectedIndex: null,
      transactionDisputeDetailsModal: false,
      transactionDisputeDetails: [],
      disputeDetailsTooltip: false,
      disputeDetailsSelectedIndex: null,
      sendNotificaitonMessage: "",
      sendNotificaitonModal: false,
    };
  }

  componentDidMount() {
    this.setState({
      camp: this.props.history.location.state.camp,
      username: this.props.history.location.state.username,
      playerName: this.props.history.location.state.playerName,
    });
    this.getTransaction(this.props.history.location.state.camp.transactionId);
  }

  getTransaction = async (transactionId) => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushTransaction/detail",
        method: "POST",
        data: { transactionId },
      });
      if (response) {
        let installmentsCreatedPlans =
          response.transaction.installmentsCreatedPlans || [];
        let showFields = installmentsCreatedPlans.filter((plan) =>
          plan.hasOwnProperty("creditAmount")
        )
          ? true
          : false;
        let allCreditCardOptions = response.transaction.allCreditCards.map(
          (creditCard) => ({
            label: `(${creditCard.name})${creditCard.number}`,
            value: creditCard.paymentMethodId,
          })
        );
        let selectedCreditCardForPayment = allCreditCardOptions.find(
          (creditCard) =>
            creditCard.value === response.transaction.paymentMethodId
        );
        this.setState({
          showLoader: false,
          showFields,
          transaction: response.transaction,
          allCreditCardOptions,
          selectedCreditCardForPayment: selectedCreditCardForPayment || {},
          stripeCards: response.transaction.allCreditCards,
          tempInstallmentsCreatedPlans:
            response.transaction.installmentsCreatedPlans || [],
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  openSendEmailPage = async () => {
    this.props.history.push({
      pathname: "/sendmail",
      state: {
        parentId: this.state.transaction.parentId,
        childId: this.state.transaction.childId,
        campId: this.state.transaction.campId,
      },
    });
  };

  // issueRefundValue = () => {
  //   if (this.state.transaction.data) {
  //     let refundAmount =
  //       (this.state.transaction.data.amount -
  //         this.state.transaction.data.application_fee_amount) /
  //       100;
  //     let refundAmountMonthly = refundAmount / 12;
  //     let currentMonth = new Date();
  //     let expiryMonth = new Date(this.state.camp.subscriptionsExpiredAt);
  //     let months = monthDiff(currentMonth, expiryMonth);
  //     refundAmount = refundAmountMonthly * months;
  //     return `$ ${refundAmount}`;
  //   }
  // };

  issueRefund = async (event) => {
    event.preventDefault();
    if (!this.state.cancelSubscription && this.state.refundAmount <= 0) {
      this.notificationSystem.addNotification({
        message: "Minimum refund value should be 1",
        level: "error",
      });
      return;
    }
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/cancelSubscription",
        method: "POST",
        data: {
          cancelFor: "child",
          childId: this.state.transaction.childId,
          parentId: this.state.transaction.parentId,
          transactionId: this.state.transaction._id,
          refundAmount: this.state.refundAmount,
          id: this.state.id,
        },
      });
      if (response) {
        this.setState({
          isOpen: false,
          showLoader: false,
          id: "",
          refundAmount: 0,
        });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.getTransaction(this.state.transaction._id);
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  toggleConfirmationModal = (cancelSubscription) => {
    this.setState({
      cancelSubscription:
        cancelSubscription === true ? cancelSubscription : false,
      confirmationModal: !this.state.confirmationModal,
    });
  };

  togglePaymentConfirmationModal = () => {
    this.setState({
      paymentConfirmationModal: !this.state.paymentConfirmationModal,
      resumePaymentDate: "",
    });
  };

  toggleReprocessDataConfirmationModal = (object) => {
    object && object.reprocessData
      ? this.setState({
          reprocessTransactionId: object._id,
          reprocessTransactionDate: object.reprocessDate,
          reprocessTransactionData: object.reprocessData,
          reprocessDataConfirmationModal: !this.state
            .reprocessDataConfirmationModal,
        })
      : this.setState({
          reprocessDataConfirmationModal: !this.state
            .reprocessDataConfirmationModal,
        });
  };

  toggleReprocessConfirmationModal = (
    reprocessTransactionId,
    reprocessTransactionPaymentType
  ) => {
    reprocessTransactionId
      ? this.setState({
          reprocessTransactionPaymentType,
          reprocessTransactions: [
            {
              transactionId: this.state.transaction._id,
              id: reprocessTransactionId,
            },
          ],
          selectedCreditCard: null,
          reprocessConfirmationModal: !this.state.reprocessConfirmationModal,
        })
      : this.setState({
          selectedCreditCard: null,
          reprocessConfirmationModal: !this.state.reprocessConfirmationModal,
        });
  };

  toggleRefundConfirmationModal = (id, maxPrice) => {
    id
      ? this.setState({
          id,
          maxPrice,
          refundAmount: 0,
          refundConfirmationModal: !this.state.refundConfirmationModal,
        })
      : this.setState({
          refundConfirmationModal: !this.state.refundConfirmationModal,
        });
  };

  toggleCashPaymentConfirmationModal = (selectedId, price) => {
    selectedId
      ? this.setState({
          selectedId,
          price,
          maxPrice: price,
          fullPayment: true,
          cashPaymentConfirmationModal: !this.state
            .cashPaymentConfirmationModal,
          selectedOption: {},
          optionNote: "",
        })
      : this.setState({
          cashPaymentConfirmationModal: !this.state
            .cashPaymentConfirmationModal,
        });
  };

  toggleInstallmentModal = (updateTempInstallments) => {
    if (updateTempInstallments) {
      this.setState({
        tempInstallmentsCreatedPlans: this.state.transaction
          .installmentsCreatedPlans,
        addInstallmentModal: !this.state.addInstallmentModal,
      });
    } else {
      this.setState({
        addInstallmentModal: !this.state.addInstallmentModal,
      });
    }
  };

  toggleSubscriptionModal = (subscription) => {
    subscription
      ? this.setState({
          subscription,
          price: subscription.price,
          totalPrice: subscription.totalPrice,
          processingFee:
            subscription.processingFeesType === "includeProcessingFees"
              ? subscription.application_fee_amount
              : subscription.processingFee,
          subscriptionDate: subscription.dueDate,
          subscriptionUpdateModal: !this.state.subscriptionUpdateModal,
        })
      : this.setState({
          subscriptionUpdateModal: !this.state.subscriptionUpdateModal,
        });
  };

  toggleInstallmentUpdateModal = (installment) => {
    installment
      ? this.setState({
          installment,
          price: installment.campPricePerInstallment,
          totalPrice: installment.price,
          processingFee:
            installment.processingFeesType === "includeProcessingFees"
              ? installment.application_fee_amount
              : installment.processingFee,
          installmentDate: installment.dueDate,
          installmentUpdateModal: !this.state.installmentUpdateModal,
        })
      : this.setState({
          installmentUpdateModal: !this.state.installmentUpdateModal,
        });
  };

  toggleUpdateCreditCardModal = () => {
    this.setState({
      selectedCreditCard: null,
      updateCreditCardModal: !this.state.updateCreditCardModal,
    });
  };

  toggleDisputeResolveModalModal = (id) => {
    id
      ? this.setState({
          disputeId: id,
          disputeResolvedNote: "",
          disputeResolveModal: !this.state.disputeResolveModal,
        })
      : this.setState({
          disputeId: "",
          disputeResolvedNote: "",
          disputeResolveModal: !this.state.disputeResolveModal,
        });
  };

  toggleTransactionDisputeDetailsModal = (
    transactionDisputeDetails,
    disputeTransactionId
  ) => {
    disputeTransactionId && transactionDisputeDetails
      ? this.setState({
          disputeTransactionId,
          transactionDisputeDetails,
          transactionDisputeDetailsModal: !this.state
            .transactionDisputeDetailsModal,
        })
      : this.setState({
          transactionDisputeDetails: [],
          transactionDisputeDetailsModal: !this.state
            .transactionDisputeDetailsModal,
        });
  };

  toggleSendNotificaitonModal = () => {
    this.setState({
      sendNotificaitonMessage: null,
      sendNotificaitonModal: !this.state.sendNotificaitonModal,
    });
  };

  sendNotificaitonToPlayer = async (event) => {
    try {
      event.preventDefault();
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/player/sendNotification",
        method: "POST",
        data: {
          message: this.state.sendNotificaitonMessage,
          username: this.state.username,
        },
      });
      if (response) {
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.setState({ showLoader: false });
        this.toggleSendNotificaitonModal();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  resolveDispute = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushTransaction/resolve/dispute",
        method: "POST",
        data: {
          transactionId: this.state.transaction._id,
          disputeTransactionId: this.state.disputeTransactionId,
          disputeId: this.state.disputeId,
          disputeResolvedNote: this.state.disputeResolvedNote,
        },
      });
      if (response) {
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.setState({ showLoader: false });
        this.getTransaction(
          this.props.history.location.state.camp.transactionId
        );
        this.toggleDisputeResolveModalModal();
        this.toggleTransactionDisputeDetailsModal();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  updateCreditCard = async () => {
    try {
      this.setState({ showLoader: true });
      let stripeCard = this.state.stripeCards.find(
        (card) => card.paymentMethodId === this.state.selectedCreditCard.value
      );
      let response = await Server.request({
        url: "rushTransaction/updateCreditCard",
        method: "POST",
        data: {
          transactionId: this.state.transaction._id,
          parentId: stripeCard.parentId,
          paymentMethodId: stripeCard.paymentMethodId,
        },
      });
      if (response) {
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.setState({ showLoader: false });
        this.toggleUpdateCreditCardModal();
        this.getTransaction(
          this.props.history.location.state.camp.transactionId
        );
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  updatePayment = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/player/payment",
        method: "POST",
        data: {
          childId: this.state.transaction.childId,
          parentId: this.state.transaction.parentId,
          transactionId: this.state.transaction._id,
          pausePayment: !this.state.transaction.pausePayment,
          resumePaymentDate: this.state.transaction.pausePayment
            ? null
            : this.state.resumePaymentDate || null,
        },
      });
      if (response) {
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.setState({ showLoader: false });
        this.getTransaction(
          this.props.history.location.state.camp.transactionId
        );
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  updateTransaction = async (type) => {
    try {
      this.setState({ showLoader: true });
      let data = {};
      switch (type) {
        case "installment":
          data = {
            interval: this.state.transaction.interval,
            transactionId: this.state.transaction._id,
            installments: this.state.tempInstallmentsCreatedPlans.length,
            installmentsCreatedPlans: this.state.tempInstallmentsCreatedPlans,
          };
          break;
        case "updateSingleInstallment":
          data = {
            updateSingleInstallment: true,
            price: this.state.price,
            interval: this.state.transaction.interval,
            transactionId: this.state.transaction._id,
            installmentId: this.state.installment._id,
            installmentDate: this.state.installmentDate,
          };
          break;
        case "subscription":
          data = {
            price: this.state.price,
            interval: this.state.transaction.interval,
            transactionId: this.state.transaction._id,
            subscriptionId: this.state.subscription._id,
            subscriptionDate: this.state.subscriptionDate,
          };
          break;
      }
      let response = await Server.request({
        url: "rushTransaction/update",
        method: "POST",
        data,
      });
      if (response) {
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.setState({ showLoader: false });
        this.getTransaction(
          this.props.history.location.state.camp.transactionId
        );
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  cashPayment = async () => {
    try {
      this.setState({ showLoader: true });
      if (!this.state.selectedOption.value) throw Error("Select the option");
      let response = await Server.request({
        url: "rushsoccer/player/cashPayment",
        method: "POST",
        data: {
          transactionId: this.state.transaction._id,
          _id: this.state.selectedId,
          price: Number(this.state.price),
          fullPayment: this.state.fullPayment,
          option: this.state.selectedOption.value,
          optionNote: this.state.optionNote,
        },
      });
      if (response) {
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.setState({ showLoader: false });
        this.toggleCashPaymentConfirmationModal();
        this.getTransaction(
          this.props.history.location.state.camp.transactionId
        );
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  getInstallmentPaymentStatus = (installmentNumber) => {
    let installment = this.state.transaction.installmentsPaid.find(
      (installment) => installment.installmentNumber === installmentNumber
    );
    return installment && installment.paymentStatus
      ? installment.paymentStatus
      : "Unpaid";
  };

  addInstallment = () => {
    const tempInstallmentsCreatedPlans = cloneDeep(
      this.state.tempInstallmentsCreatedPlans
    );
    const installmentsPaid = cloneDeep(this.state.transaction.installmentsPaid);
    let paidInstallmentNumbers = installmentsPaid.map(
      (installment) => installment.installmentNumber
    );
    let unPaidInstallments = tempInstallmentsCreatedPlans.filter(
      (installment) =>
        !paidInstallmentNumbers.includes(installment.installmentNumber)
    );
    let totalAmount = unPaidInstallments.reduce(
      (previousValue, currentValue) => {
        let price = 0;
        if (currentValue.processingFeesType === "includeProcessingFees") {
          price = currentValue.price;
        } else {
          price =
            currentValue.price -
            currentValue.processingFee -
            config.flatFeeForConnectedUser;
        }
        return (previousValue += price);
      },
      0
    );
    let totalUnPaidInstallments = unPaidInstallments.length + 1;
    let installmentAmount = totalAmount / totalUnPaidInstallments;
    let amount =
      (installmentAmount + config.flatFeePerTransaction) /
      (1 - this.state.transaction.camp.processingFee / 100);
    let processingFees =
      amount - installmentAmount - config.flatFeeForConnectedUser;
    if (unPaidInstallments[0].processingFeesType === "includeProcessingFees")
      amount = installmentAmount;
    tempInstallmentsCreatedPlans.map((installment) => {
      if (
        unPaidInstallments.find(
          (unPaidInstallment) =>
            unPaidInstallment.installmentNumber ===
            installment.installmentNumber
        )
      ) {
        installment.price = Number(Number(amount).toFixed(2));
        installment.processingFeesType === "includeProcessingFees"
          ? (installment.application_fee_amount = Number(
              Number(processingFees).toFixed(2)
            ))
          : (installment.processingFee = Number(
              Number(processingFees).toFixed(2)
            ));
      }
    });
    let lastInstallment = unPaidInstallments[unPaidInstallments.length - 1];
    let dueDate = new Date(lastInstallment.dueDate);
    dueDate.setUTCMonth(dueDate.getMonth() + 1);
    dueDate.setUTCHours(12, 0, 0, 0);
    tempInstallmentsCreatedPlans.push({
      _id: uuidv4(),
      price: Number(Number(amount).toFixed(2)),
      dueDate: dueDate.toISOString(),
      installmentNumber: tempInstallmentsCreatedPlans.length + 1,
      processingFeesType: unPaidInstallments[0].processingFeesType,
      processingFee:
        unPaidInstallments[0].processingFeesType === "includeProcessingFees"
          ? 0
          : Number(Number(processingFees).toFixed(2)),
      application_fee_amount:
        unPaidInstallments[0].processingFeesType === "includeProcessingFees"
          ? Number(Number(processingFees).toFixed(2))
          : 0,
      version: "v2",
    });
    this.setState({
      showLoader: false,
      tempInstallmentsCreatedPlans: tempInstallmentsCreatedPlans,
    });
  };

  removeInstallment = () => {
    const tempInstallmentsCreatedPlans = cloneDeep(
      this.state.tempInstallmentsCreatedPlans
    );
    const installmentsPaid = cloneDeep(this.state.transaction.installmentsPaid);
    let paidInstallmentNumbers = installmentsPaid.map(
      (installment) => installment.installmentNumber
    );
    let unPaidInstallments = tempInstallmentsCreatedPlans.filter(
      (installment) =>
        !paidInstallmentNumbers.includes(installment.installmentNumber)
    );
    if (unPaidInstallments.length > 1) {
      let totalAmount = unPaidInstallments.reduce(
        (previousValue, currentValue) => {
          let price = 0;
          if (currentValue.processingFeesType === "includeProcessingFees") {
            price = currentValue.price;
          } else {
            price =
              currentValue.price -
              currentValue.processingFee -
              config.flatFeeForConnectedUser;
          }
          return (previousValue += price);
        },
        0
      );
      let totalUnPaidInstallments = unPaidInstallments.length - 1;
      let installmentAmount = totalAmount / totalUnPaidInstallments;
      let amount =
        (installmentAmount + config.flatFeePerTransaction) /
        (1 - this.state.transaction.camp.processingFee / 100);
      let processingFees =
        amount - installmentAmount - config.flatFeeForConnectedUser;
      if (unPaidInstallments[0].processingFeesType === "includeProcessingFees")
        amount = installmentAmount;
      tempInstallmentsCreatedPlans.pop();
      tempInstallmentsCreatedPlans.map((installment) => {
        if (
          unPaidInstallments.find(
            (unPaidInstallment) =>
              unPaidInstallment.installmentNumber ===
              installment.installmentNumber
          )
        ) {
          installment.price = Number(Number(amount).toFixed(2));
          installment.processingFeesType === "includeProcessingFees"
            ? (installment.application_fee_amount = Number(
                Number(processingFees).toFixed(2)
              ))
            : (installment.processingFee = Number(
                Number(processingFees).toFixed(2)
              ));
        }
      });
      this.setState({
        showLoader: false,
        tempInstallmentsCreatedPlans: tempInstallmentsCreatedPlans,
      });
    }
  };

  updateReprocessDate = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushTransaction/update/reprocessTransactionDate",
        method: "POST",
        data: {
          transactionId: this.state.transaction._id,
          reprocessTransactionId: this.state.reprocessTransactionId,
          reprocessTransactionDate: this.state.reprocessTransactionDate,
          interval: this.state.transaction.interval,
        },
      });
      if (response) {
        this.setState({
          showLoader: false,
          updateReprocessDate: false,
        });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.toggleReprocessDataConfirmationModal();
        this.getTransaction(this.state.transaction._id);
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  reprocessTransactions = async () => {
    try {
      this.setState({ showLoader: true });
      let paymentMethodId = this.state.selectedCreditCard
        ? this.state.selectedCreditCard.value
        : null;
      let stripeCard = this.state.stripeCards.find(
        (card) => card.paymentMethodId === paymentMethodId
      );
      let response = await Server.request({
        url: "rushsoccer/reprocess/transaction",
        method: "POST",
        data: {
          fromWeb: true,
          transactions: this.state.reprocessTransactions,
          paymentMethodId: stripeCard ? stripeCard.paymentMethodId : null,
          creditCardParentId: stripeCard ? stripeCard.parentId : null,
        },
      });
      if (response) {
        this.setState({ showLoader: false });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.toggleReprocessConfirmationModal();
        this.getTransaction(this.state.transaction._id);
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  // renderDiscountPrice = (interval, obj) => {
  //   let discountPrice = 0;
  //   let teamDiscountAmount = 0;
  //   let totalDiscount = 0;
  //   switch (interval) {
  //     case "onetime":
  //       discountPrice = this.state.transaction.discountPrice
  //         ? this.state.transaction.discountPrice
  //         : 0;
  //       teamDiscountAmount = this.state.transaction.teamDiscountAmount
  //         ? this.state.transaction.teamDiscountAmount
  //         : 0;
  //       totalDiscount = Number(discountPrice) + Number(teamDiscountAmount);
  //       return totalDiscount ? `$ ${totalDiscount.toFixed(2)}` : "0.00";
  //     case "subscriptions":
  //       discountPrice = obj.discountPrice ? obj.discountPrice : 0;
  //       teamDiscountAmount = obj.teamDiscountAmount
  //         ? obj.teamDiscountAmount
  //         : 0;
  //       totalDiscount = Number(discountPrice) + Number(teamDiscountAmount);
  //       return totalDiscount ? `$ ${totalDiscount.toFixed(2)}` : "0.00";
  //   }
  // };

  renderFailedTransactionButton = () => {
    switch (this.state.transaction.interval) {
      case "month":
        let failedInstallments = this.state.transaction.installmentsPaid.filter(
          (installmentPaid) => installmentPaid.paymentStatus === "failed"
        );
        if (failedInstallments && failedInstallments.length) {
          return (
            <Button
              className="mr-4"
              onClick={() => {
                let reprocessTransactions = failedInstallments.map(
                  (failedInstallment) => ({
                    transactionId: this.state.transaction._id,
                    id: failedInstallment._id,
                  })
                );
                this.setState({ reprocessTransactions }, () =>
                  this.toggleReprocessConfirmationModal()
                );
              }}
            >
              Reprocess Failed Transactions
            </Button>
          );
        } else {
          return null;
        }
      case "monthly subscription":
        let subscriptions = this.state.transaction.subscriptions.filter(
          (subscription) => subscription.paymentStatus === "failed"
        );
        if (subscriptions && subscriptions.length) {
          return (
            <Button
              className="mr-4"
              onClick={() => {
                let reprocessTransactions = subscriptions.map(
                  (subscription) => ({
                    transactionId: this.state.transaction._id,
                    id: subscription._id,
                  })
                );
                this.setState({ reprocessTransactions }, () =>
                  this.toggleReprocessConfirmationModal()
                );
              }}
            >
              Reprocess Failed Transactions
            </Button>
          );
        } else {
          return null;
        }
      default:
        return null;
    }
  };

  renderRefundButton = (object, type, index) => {
    switch (type) {
      case "subscription":
        switch (object.paymentStatus) {
          case "failed":
            return (
              <>
                <BsPlusCircle
                  id={`subscriptionFailedCashPaymentTooltip${index}`}
                  size="25px"
                  style={{
                    outline: "unset",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    this.toggleCashPaymentConfirmationModal(
                      object._id,
                      object.price
                    )
                  }
                  onMouseOver={() =>
                    this.setState({
                      subscriptionSelectedIndex: index,
                      subscriptionFailedCashPaymentTooltip: true,
                    })
                  }
                  onMouseOut={() =>
                    this.setState({
                      subscriptionSelectedIndex: null,
                      subscriptionFailedCashPaymentTooltip: false,
                    })
                  }
                />
                <Tooltip
                  placement="bottom"
                  isOpen={
                    this.state.subscriptionFailedCashPaymentTooltip &&
                    this.state.subscriptionSelectedIndex === index
                  }
                  target={`subscriptionFailedCashPaymentTooltip${index}`}
                  toggle={() => {}}
                >
                  Payment
                </Tooltip>
                <GoCreditCard
                  id={`subscriptionReprocessTooltip${index}`}
                  size="25px"
                  style={{
                    outline: "unset",
                    cursor: "pointer",
                    marginLeft: "5px",
                  }}
                  onClick={() =>
                    this.toggleReprocessConfirmationModal(
                      object._id,
                      object.paymentType
                    )
                  }
                  onMouseOver={() =>
                    this.setState({
                      subscriptionSelectedIndex: index,
                      subscriptionReprocessTooltip: true,
                    })
                  }
                  onMouseOut={() =>
                    this.setState({
                      subscriptionSelectedIndex: null,
                      subscriptionReprocessTooltip: false,
                    })
                  }
                />
                <Tooltip
                  placement="bottom"
                  isOpen={
                    this.state.subscriptionReprocessTooltip &&
                    this.state.subscriptionSelectedIndex === index
                  }
                  target={`subscriptionReprocessTooltip${index}`}
                  toggle={() => {}}
                >
                  Reprocess Transaction
                </Tooltip>
                <IoIosEye
                  id={`subscriptionViewReprocessTooltip${index}`}
                  size="25px"
                  style={{
                    outline: "unset",
                    cursor: "pointer",
                    marginLeft: "5px",
                  }}
                  onClick={() =>
                    this.toggleReprocessDataConfirmationModal(object)
                  }
                  onMouseOver={() =>
                    this.setState({
                      subscriptionSelectedIndex: index,
                      subscriptionViewReprocessTooltip: true,
                    })
                  }
                  onMouseOut={() =>
                    this.setState({
                      subscriptionSelectedIndex: null,
                      subscriptionViewReprocessTooltip: false,
                    })
                  }
                />
                <Tooltip
                  placement="bottom"
                  isOpen={
                    this.state.subscriptionViewReprocessTooltip &&
                    this.state.subscriptionSelectedIndex === index
                  }
                  target={`subscriptionViewReprocessTooltip${index}`}
                  toggle={() => {}}
                >
                  View Reprocess Transaction Detail
                </Tooltip>
              </>
            );
          case "refund":
            return "-";
          case "invalid":
            return "-";
          default:
            return object.paymentType === "card" ? (
              <>
                <HiOutlineReceiptRefund
                  id={`subscriptionRefundTooltip${index}`}
                  size="25px"
                  style={{
                    outline: "unset",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    this.toggleRefundConfirmationModal(
                      object._id,
                      object.totalPrice
                    )
                  }
                  onMouseOver={() =>
                    this.setState({
                      subscriptionSelectedIndex: index,
                      subscriptionRefundTooltip: true,
                    })
                  }
                  onMouseOut={() =>
                    this.setState({
                      subscriptionSelectedIndex: null,
                      subscriptionRefundTooltip: false,
                    })
                  }
                ></HiOutlineReceiptRefund>
                <Tooltip
                  placement="bottom"
                  isOpen={
                    this.state.subscriptionRefundTooltip &&
                    this.state.subscriptionSelectedIndex === index
                  }
                  target={`subscriptionRefundTooltip${index}`}
                  toggle={() => {}}
                >
                  Initiate Refund
                </Tooltip>
              </>
            ) : (
              "-"
            );
        }
      case "installment":
        let installmentsPaid = this.state.transaction.installmentsPaid.find(
          (installment) =>
            installment.installmentNumber === object.installmentNumber
        );
        switch (installmentsPaid.paymentStatus) {
          case "failed":
            return (
              <>
                <BsPlusCircle
                  id={`installmentFailedCashPaymentTooltip${index}`}
                  size="25px"
                  style={{
                    outline: "unset",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    this.toggleCashPaymentConfirmationModal(
                      object._id,
                      object.campPricePerInstallment
                    )
                  }
                  onMouseOver={() =>
                    this.setState({
                      installmentSelectedIndex: index,
                      installmentFailedCashPaymentTooltip: true,
                    })
                  }
                  onMouseOut={() =>
                    this.setState({
                      installmentSelectedIndex: null,
                      installmentFailedCashPaymentTooltip: false,
                    })
                  }
                />
                <Tooltip
                  placement="bottom"
                  isOpen={
                    this.state.installmentFailedCashPaymentTooltip &&
                    this.state.installmentSelectedIndex === index
                  }
                  target={`installmentFailedCashPaymentTooltip${index}`}
                  toggle={() => {}}
                >
                  Payment
                </Tooltip>
                <GoCreditCard
                  id={`installmentReprocessTooltip${index}`}
                  size="25px"
                  style={{
                    outline: "unset",
                    cursor: "pointer",
                    marginLeft: "5px",
                  }}
                  onClick={() =>
                    this.toggleReprocessConfirmationModal(
                      installmentsPaid._id,
                      installmentsPaid.paymentType
                    )
                  }
                  onMouseOver={() =>
                    this.setState({
                      installmentSelectedIndex: index,
                      installmentReprocessTooltip: true,
                    })
                  }
                  onMouseOut={() =>
                    this.setState({
                      installmentSelectedIndex: null,
                      installmentReprocessTooltip: false,
                    })
                  }
                />
                <Tooltip
                  placement="bottom"
                  isOpen={
                    this.state.installmentReprocessTooltip &&
                    this.state.installmentSelectedIndex === index
                  }
                  target={`installmentReprocessTooltip${index}`}
                  toggle={() => {}}
                >
                  Reprocess Transaction
                </Tooltip>
                <IoIosEye
                  id={`installmentViewReprocessTooltip${index}`}
                  size="25px"
                  style={{
                    outline: "unset",
                    cursor: "pointer",
                    marginLeft: "5px",
                  }}
                  onClick={() =>
                    this.toggleReprocessDataConfirmationModal(object)
                  }
                  onMouseOver={() =>
                    this.setState({
                      installmentSelectedIndex: index,
                      installmentViewReprocessTooltip: true,
                    })
                  }
                  onMouseOut={() =>
                    this.setState({
                      installmentSelectedIndex: null,
                      installmentViewReprocessTooltip: false,
                    })
                  }
                />
                <Tooltip
                  placement="bottom"
                  isOpen={
                    this.state.installmentViewReprocessTooltip &&
                    this.state.installmentSelectedIndex === index
                  }
                  target={`installmentViewReprocessTooltip${index}`}
                  toggle={() => {}}
                >
                  View Reprocess Transaction Detail
                </Tooltip>
              </>
            );
          case "refund":
            return "-";
          case "invalid":
            return "-";
          default:
            return installmentsPaid.paymentType === "card" ? (
              <>
                <HiOutlineReceiptRefund
                  id={`installmentRefundTooltip${index}`}
                  size="25px"
                  style={{
                    outline: "unset",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    this.toggleRefundConfirmationModal(
                      object._id,
                      object.totalPrice
                    )
                  }
                  onMouseOver={() =>
                    this.setState({
                      installmentSelectedIndex: index,
                      installmentRefundTooltip: true,
                    })
                  }
                  onMouseOut={() =>
                    this.setState({
                      installmentSelectedIndex: null,
                      installmentRefundTooltip: false,
                    })
                  }
                />
                <Tooltip
                  placement="bottom"
                  isOpen={
                    this.state.installmentRefundTooltip &&
                    this.state.installmentSelectedIndex === index
                  }
                  target={`installmentRefundTooltip${index}`}
                  toggle={() => {}}
                >
                  Initiate Refund
                </Tooltip>
              </>
            ) : (
              "-"
            );
        }
      default:
        return null;
    }
  };

  renderPaymentStatus = (installment) => {
    let installmentPaid = this.state.transaction.installmentsPaid.find(
      (installmentPaid) =>
        installmentPaid.installmentNumber === installment.installmentNumber
    );
    if (installmentPaid && installmentPaid.paymentStatus) {
      if (installmentPaid.paymentStatus === "pending") {
        return "-";
      } else if (installmentPaid.paymentStatus === "invalid") {
        return (
          <BsExclamationTriangleFill
            size="20px"
            style={{ color: "#ffc107" }}
          ></BsExclamationTriangleFill>
        );
      } else {
        if (installmentPaid.paymentStatus === "paid") {
          return (
            <ImCheckmark size="20px" style={{ color: "green" }}></ImCheckmark>
          );
        } else {
          return <ImCross size="20px" style={{ color: "red" }}></ImCross>;
        }
      }
    } else {
      return "-";
    }
  };

  renderPaymentType = (installment) => {
    let installmentPaid = this.state.transaction.installmentsPaid.find(
      (installmentPaid) =>
        installmentPaid.installmentNumber === installment.installmentNumber
    );
    if (installmentPaid && installmentPaid.paymentType) {
      return capitalizeFirstLetter(installmentPaid.paymentType);
    } else {
      return "-";
    }
  };

  updateTransactionAmount = (price, type) => {
    price = Number(price);
    let totalPrice = 0;
    let processingFee = 0;
    switch (type) {
      case "subscription":
        switch (this.state.transaction.paymentType) {
          case "card":
            totalPrice =
              (price + config.flatFeePerTransaction) /
              (1 - this.state.transaction.camp.processingFee / 100);
            processingFee = totalPrice - price - config.flatFeeForConnectedUser;
            if (
              this.state.subscription.processingFeesType ===
              "includeProcessingFees"
            )
              totalPrice = price;
            this.setState({
              price,
              totalPrice: Number(totalPrice.toFixed(2)),
              processingFee: Number(processingFee.toFixed(2)),
            });
            break;
          case "bank_debit":
            totalPrice =
              (price + config.flatFeePerTransaction) /
              (1 - this.state.transaction.camp.bankAccountProcessingFee / 100);
            processingFee = totalPrice - price - config.flatFeeForConnectedUser;
            if (
              this.state.subscription.processingFeesType ===
              "includeProcessingFees"
            )
              totalPrice = price;
            this.setState({
              price,
              totalPrice: Number(totalPrice.toFixed(2)),
              processingFee: Number(processingFee.toFixed(2)),
            });
            break;
        }
        break;
      case "installment":
        switch (this.state.transaction.paymentType) {
          case "card":
            totalPrice =
              (price + config.flatFeePerTransaction) /
              (1 - this.state.transaction.camp.processingFee / 100);
            processingFee = totalPrice - price - config.flatFeeForConnectedUser;
            if (
              this.state.installment.processingFeesType ===
              "includeProcessingFees"
            )
              totalPrice = price;
            this.setState({
              price,
              totalPrice: Number(totalPrice.toFixed(2)),
              processingFee: Number(processingFee.toFixed(2)),
            });
            break;
          case "bank_debit":
            totalPrice =
              (price + config.flatFeePerTransaction) /
              (1 - this.state.transaction.camp.bankAccountProcessingFee / 100);
            processingFee = totalPrice - price - config.flatFeeForConnectedUser;
            if (
              this.state.installment.processingFeesType ===
              "includeProcessingFees"
            )
              totalPrice = price;
            this.setState({
              price,
              totalPrice: Number(totalPrice.toFixed(2)),
              processingFee: Number(processingFee.toFixed(2)),
            });
            break;
        }
        break;
    }
  };

  renderResumePaymentMessage = () => {
    if (this.state.transaction && this.state.transaction.pausePayment) {
      switch (this.state.transaction.interval) {
        case "monthly subscription":
          return this.state.transaction.status !== "cancelled"
            ? this.state.transaction.resumePaymentDate
              ? ` (Payment will be resume on ${moment
                  .utc(this.state.transaction.resumePaymentDate)
                  .format("LL")})`
              : ` (Payment resume date not set)`
            : null;
        case "month":
          return this.state.transaction.status === "partial paid"
            ? this.state.transaction.resumePaymentDate
              ? ` (Payment will be resume on ${moment
                  .utc(this.state.transaction.resumePaymentDate)
                  .format("LL")})`
              : ` (Payment resume date not set)`
            : null;
        default:
          return null;
      }
    }
  };

  renderUpdateCreditCardButton = () => {
    switch (this.state.transaction.interval) {
      case "monthly subscription":
        return this.state.transaction.status !== "cancelled" &&
          this.state.transaction.paymentType !== "bank_debit" ? (
          <Button
            style={{ float: "right" }}
            className="mr-2"
            onClick={() => this.toggleUpdateCreditCardModal()}
          >
            Update credit card
          </Button>
        ) : null;
      case "month":
        return this.state.transaction.status === "partial paid" &&
          this.state.transaction.paymentType !== "bank_debit" ? (
          <Button
            style={{ float: "right" }}
            className="mr-2"
            onClick={() => this.toggleUpdateCreditCardModal()}
          >
            Update credit card
          </Button>
        ) : null;
      default:
        return null;
    }
  };

  render() {
    return (
      <div>
        <PageSpinner showLoader={this.state.showLoader} />
        <Page
          title="Player Payment Detail"
          breadcrumbs={[{ name: "Player Payment Detail", active: true }]}
        >
          <Row style={{ marginTop: 10 }}>
            <Col>
              <Card>
                <div
                  style={{
                    margin: 20,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexShrink: 1,
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "column",
                      padding: 5,
                    }}
                  >
                    <div style={{ fontSize: 30 }}>
                      {this.state.camp.campName}
                    </div>
                  </div>
                  <Row>
                    <Col>
                      <div style={{ fontSize: 15, color: "rgb(23, 81, 123)" }}>
                        Transaction Id
                      </div>
                      <div style={{ fontSize: 15 }}>
                        {this.state.camp.transactionId}
                      </div>
                    </Col>
                    <Col>
                      <div style={{ fontSize: 15, color: "rgb(23, 81, 123)" }}>
                        Issue Date
                      </div>
                      <div style={{ fontSize: 15 }}>
                        {moment
                          .utc(this.state.transaction.createdAt)
                          .format("LL")}
                      </div>
                    </Col>
                    <Col>
                      <div style={{ fontSize: 15, color: "rgb(23, 81, 123)" }}>
                        Status
                      </div>
                      <div style={{ fontSize: 15, fontWeight: "bold" }}>
                        {this.state.camp.status &&
                          capitalizeFirstLetter(this.state.camp.status)}
                      </div>
                    </Col>
                    <Col>
                      <h4 style={{ fontSize: 30, color: "rgb(23, 81, 123)" }}>
                        {this.state.playerName}
                      </h4>
                      <Row
                        style={{ paddingLeft: "15px", alignItems: "center" }}
                      >
                        <div
                          style={{
                            marginRight: 5,
                            outline: "unset",
                            cursor: "pointer",
                          }}
                          onClick={() => this.openSendEmailPage()}
                        >
                          <IoMdMailOpen size="20px" color="rgb(23, 81, 123)" />
                        </div>
                        <div
                          style={{
                            outline: "unset",
                            cursor: "pointer",
                            fontSize: 25,
                            color: "rgb(23, 81, 123)",
                          }}
                          onClick={() => this.openSendEmailPage()}
                        >
                          Send Message
                        </div>
                      </Row>
                      <Row
                        style={{ paddingLeft: "15px", alignItems: "center" }}
                      >
                        <div
                          style={{
                            marginRight: 5,
                            outline: "unset",
                            cursor: "pointer",
                          }}
                          onClick={() => this.toggleSendNotificaitonModal()}
                        >
                          <IoMdNotifications
                            size="20px"
                            color="rgb(23, 81, 123)"
                          />
                        </div>
                        <div
                          style={{
                            outline: "unset",
                            cursor: "pointer",
                            fontSize: 25,
                            color: "rgb(23, 81, 123)",
                          }}
                          onClick={() => this.toggleSendNotificaitonModal()}
                        >
                          Send Notification
                        </div>
                      </Row>
                    </Col>
                  </Row>
                  <Row style={{ marginTop: 20 }}>
                    <Col>
                      <div style={{ fontSize: 15, color: "rgb(23, 81, 123)" }}>
                        {this.state.transaction.interval === "onetime"
                          ? "Payment Id"
                          : this.state.transaction.interval === "month"
                          ? "Installment Id"
                          : "Subscritpion Id"}
                      </div>
                      <div style={{ fontSize: 15, fontWeight: "bold" }}>
                        {(this.state.transaction.data &&
                          this.state.transaction.data.id) ||
                          "-"}
                      </div>
                    </Col>
                    <Col>
                      <div style={{ fontSize: 15, color: "rgb(23, 81, 123)" }}>
                        Payment Status
                      </div>
                      <div style={{ fontSize: 15, fontWeight: "bold" }}>
                        {this.state.transaction.status &&
                          capitalizeFirstLetter(this.state.transaction.status)}
                      </div>
                    </Col>
                    <Col>
                      <div style={{ fontSize: 15, color: "rgb(23, 81, 123)" }}>
                        Total amount
                      </div>
                      <div style={{ fontSize: 15, fontWeight: "bold" }}>
                        ${Number(this.state.transaction.campPrice).toFixed(2)}
                      </div>
                    </Col>
                    <Col>
                      <div style={{ fontSize: 15, color: "rgb(23, 81, 123)" }}>
                        Balance Due
                      </div>
                      <div style={{ fontSize: 15, fontWeight: "bold" }}>
                        $
                        {Number(this.state.transaction.pendingPrice).toFixed(2)}
                      </div>
                    </Col>
                    {this.state.transaction.status === "refund" && (
                      <Col>
                        <div
                          style={{ fontSize: 15, color: "rgb(23, 81, 123)" }}
                        >
                          Refunded Amount
                        </div>
                        <div style={{ fontSize: 15, fontWeight: "bold" }}>
                          ${this.state.transaction.refundData.amount / 100}
                        </div>
                      </Col>
                    )}
                  </Row>
                  <Row>
                    <Col>
                      <div className="d-flex justify-content-end">
                        {this.state.transaction.installments !== 0 &&
                          Object.keys(this.state.transaction).length !== 0 &&
                          this.state.tempInstallmentsCreatedPlans.length !==
                            this.state.transaction.installmentsPaid.length && (
                            <Button
                              className="mr-4"
                              onClick={() => this.toggleInstallmentModal(true)}
                            >
                              Add/Remove Installment
                            </Button>
                          )}
                        {this.state.transaction.interval === "onetime"
                          ? this.state.transaction.status !== "refund" && (
                              <Button
                                id="toggler"
                                className="mr-4"
                                onClick={() => {
                                  this.setState({ isOpen: !this.state.isOpen });
                                }}
                              >
                                Issue Refund
                              </Button>
                            )
                          : this.state.transaction.status !== "cancelled" &&
                            (this.state.transaction.interval === "month" ? (
                              this.state.transaction.status !== "paid" && (
                                <>
                                  <Button
                                    className="mr-4"
                                    onClick={() =>
                                      this.togglePaymentConfirmationModal()
                                    }
                                  >
                                    {this.state.transaction &&
                                    this.state.transaction.pausePayment
                                      ? "Resume Payment"
                                      : "Pause Payment"}
                                  </Button>
                                  <Button
                                    id="toggler"
                                    className="mr-4"
                                    onClick={() =>
                                      this.toggleConfirmationModal(true)
                                    }
                                  >
                                    Cancel Subscritpion
                                  </Button>
                                </>
                              )
                            ) : (
                              <>
                                <Button
                                  className="mr-4"
                                  onClick={() =>
                                    this.togglePaymentConfirmationModal()
                                  }
                                >
                                  {this.state.transaction &&
                                  this.state.transaction.pausePayment
                                    ? "Resume Payment"
                                    : "Pause Payment"}
                                </Button>
                                <Button
                                  id="toggler"
                                  className="mr-4"
                                  onClick={() =>
                                    this.toggleConfirmationModal(true)
                                  }
                                >
                                  Cancel Subscritpion
                                </Button>
                              </>
                            ))}
                        {this.renderFailedTransactionButton()}
                      </div>
                      <div className="mt-3">
                        <UncontrolledCollapse
                          toggler="#toggler"
                          isOpen={this.state.isOpen}
                        >
                          <Card>
                            <CardBody>
                              {/* <Row>
                                <Col xl={6} lg={12} md={12}>
                                  <FormGroup>
                                    <Label for="totalAmount">
                                      Total Amount
                                    </Label>
                                    <Input
                                      disabled
                                      type="text"
                                      name="totalAmount"
                                      value={`$ ${
                                        this.state.transaction &&
                                        this.state.transaction.campPrice
                                      }`}
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                              <Row>
                                <Col xl={6} lg={12} md={12}>
                                  <FormGroup>
                                    <Label for="name">Processing Fee</Label>
                                    <Input
                                      disabled
                                      type="text"
                                      name="processingFee"
                                      value={`$ ${
                                        this.state.transaction.data &&
                                        this.state.transaction.data
                                          .application_fee_amount / 100
                                      }`}
                                    />
                                  </FormGroup>
                                </Col>
                              </Row> */}
                              <Row>
                                <Col xl={6} lg={12} md={12}>
                                  <FormGroup>
                                    <Label for="refundAmount">
                                      Refund Amount
                                    </Label>
                                    <Input
                                      type="number"
                                      name="refundAmount"
                                      value={this.state.refundAmount}
                                      onChange={(event) => {
                                        let newPrice = this.state.transaction
                                          .campPrice;
                                        if (this.state.refundProcessingFees) {
                                          newPrice = this.state.transaction
                                            .price;
                                        }
                                        if (
                                          event.target.value >= 0 &&
                                          event.target.value <= newPrice
                                        ) {
                                          this.setState({
                                            refundAmount: event.target.value,
                                          });
                                        }
                                      }}
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                              <Row>
                                <Col xl={6} lg={12} md={12}>
                                  <div className="ml-4">
                                    <Input
                                      type="checkbox"
                                      style={{ width: "15px", height: "15px" }}
                                      checked={this.state.refundProcessingFees}
                                      onChange={() =>
                                        this.setState({
                                          refundAmount: 0,
                                          refundProcessingFees: !this.state
                                            .refundProcessingFees,
                                        })
                                      }
                                    ></Input>
                                    <Label>Refund Processing Fee</Label>
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col xl={6} lg={12} md={12}>
                                  <FormGroup>
                                    <Button
                                      className="mr-4"
                                      onClick={this.toggleConfirmationModal}
                                    >
                                      Initiate Refund
                                    </Button>
                                  </FormGroup>
                                </Col>
                              </Row>
                            </CardBody>
                          </Card>
                        </UncontrolledCollapse>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Card>
              <Row>
                <Col>
                  <Card className="mt-3">
                    <CardHeader>
                      Payment Plan
                      {this.renderResumePaymentMessage()}
                      {this.renderUpdateCreditCardButton()}
                    </CardHeader>
                    <CardBody>
                      <Row>
                        <Col>
                          <Card body>
                            {this.state.transaction.interval === "onetime" ? (
                              //For full payment data
                              <Table bordered responsive>
                                <thead>
                                  <tr>
                                    <th>Dispute Raised</th>
                                    <th>Event Price</th>
                                    <th>Discount Price</th>
                                    <th>Credit Amount</th>
                                    <th>Due Amount</th>
                                    <th>Amount Paid</th>
                                    <th>Processing Fee</th>
                                    <th>Net Amount</th>
                                    <th>Payment Status</th>
                                    <th>Paid on</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td
                                      style={{
                                        textAlign: "center",
                                      }}
                                    >
                                      {this.state.transaction.disputeRaised ? (
                                        <div className="d-flex">
                                          <IoMdFlag
                                            size="27px"
                                            style={{
                                              color: "#ff7c00",
                                            }}
                                          />
                                          <IoIosEye
                                            id="disputeDetailsTooltip"
                                            size="27px"
                                            style={{
                                              outline: "unset",
                                              cursor: "pointer",
                                            }}
                                            onClick={() =>
                                              this.toggleTransactionDisputeDetailsModal(
                                                this.state.transaction
                                                  .disputeDetails,
                                                this.state.transaction._id
                                              )
                                            }
                                            onMouseOver={() =>
                                              this.setState({
                                                disputeDetailsTooltip: true,
                                              })
                                            }
                                            onMouseOut={() =>
                                              this.setState({
                                                disputeDetailsTooltip: false,
                                              })
                                            }
                                          />
                                          <Tooltip
                                            placement="bottom"
                                            isOpen={
                                              this.state.disputeDetailsTooltip
                                            }
                                            target="disputeDetailsTooltip"
                                            toggle={() => {}}
                                          >
                                            View Dispute Details
                                          </Tooltip>
                                        </div>
                                      ) : (
                                        <>
                                          <IoIosEye
                                            id="disputeDetailsTooltip"
                                            size="27px"
                                            style={{
                                              outline: "unset",
                                              cursor: "pointer",
                                            }}
                                            onClick={() =>
                                              this.toggleTransactionDisputeDetailsModal(
                                                this.state.transaction
                                                  .disputeDetails,
                                                this.state.transaction._id
                                              )
                                            }
                                            onMouseOver={() =>
                                              this.setState({
                                                disputeDetailsTooltip: true,
                                              })
                                            }
                                            onMouseOut={() =>
                                              this.setState({
                                                disputeDetailsTooltip: false,
                                              })
                                            }
                                          />
                                          <Tooltip
                                            placement="bottom"
                                            isOpen={
                                              this.state.disputeDetailsTooltip
                                            }
                                            target="disputeDetailsTooltip"
                                            toggle={() => {}}
                                          >
                                            View Dispute Details
                                          </Tooltip>
                                        </>
                                      )}
                                    </td>
                                    <td>
                                      ${" "}
                                      {this.state.transaction.campPrice
                                        ? this.state.transaction.campPrice.toFixed(
                                            2
                                          )
                                        : "0.00"}
                                    </td>
                                    <td>
                                      {/* {this.renderDiscountPrice("onetime")} */}
                                      ${" "}
                                      {this.state.transaction.discountPrice
                                        ? this.state.transaction.discountPrice.toFixed(
                                            2
                                          )
                                        : "0.00"}
                                    </td>
                                    <td>
                                      ${" "}
                                      {this.state.transaction.creditAmount
                                        ? this.state.transaction.creditAmount.toFixed(
                                            2
                                          )
                                        : "0.00"}
                                    </td>
                                    <td>
                                      ${" "}
                                      {this.state.transaction.dueAmount
                                        ? this.state.transaction.dueAmount.toFixed(
                                            2
                                          )
                                        : "0.00"}
                                    </td>
                                    <td>
                                      ${" "}
                                      {this.state.transaction.price
                                        ? this.state.transaction.price.toFixed(
                                            2
                                          )
                                        : "0.00"}
                                    </td>
                                    <td>
                                      ${" "}
                                      {this.state.transaction.price !== 0
                                        ? (
                                            this.state.transaction.data
                                              .application_fee_amount / 100
                                          ).toFixed(2)
                                        : "0.00"}
                                    </td>
                                    <td>
                                      ${" "}
                                      {this.state.transaction.price !== 0
                                        ? Number(
                                            this.state.transaction.price -
                                              this.state.transaction.data
                                                .application_fee_amount /
                                                100
                                          ).toFixed(2)
                                        : "0.00"}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {this.state.transaction.status &&
                                      this.state.transaction.status ===
                                        "paid" ? (
                                        <ImCheckmark
                                          size="20px"
                                          style={{ color: "green" }}
                                        ></ImCheckmark>
                                      ) : (
                                        <ImCross
                                          size="20px"
                                          style={{ color: "red" }}
                                        ></ImCross>
                                      )}
                                    </td>
                                    <td>
                                      {moment
                                        .utc(this.state.transaction.createdAt)
                                        .format("LL")}
                                    </td>
                                  </tr>
                                </tbody>
                              </Table>
                            ) : this.state.transaction.interval ===
                              "monthly subscription" ? (
                              //For monthly subscription data
                              <Table bordered responsive>
                                <thead>
                                  <tr>
                                    <th>Dispute Raised</th>
                                    <th>Due Date</th>
                                    <th>Subscription Price</th>
                                    <th>Discount Price</th>
                                    <th>Credit Amount</th>
                                    <th>Due Amount</th>
                                    <th>Amount Paid</th>
                                    <th>Processing Fee</th>
                                    <th>Net Amount</th>
                                    <th>Payment Status</th>
                                    <th>Paid on</th>
                                    <th>Actions</th>
                                    <th>Payment Type</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.transaction.subscriptions &&
                                    this.state.transaction.subscriptions.map(
                                      (subscription, index) => (
                                        <tr key={index}>
                                          <td
                                            style={{
                                              textAlign: "center",
                                            }}
                                          >
                                            {subscription.disputeRaised ? (
                                              <div className="d-flex">
                                                <IoMdFlag
                                                  size="27px"
                                                  style={{
                                                    color: "#ff7c00",
                                                  }}
                                                />
                                                <IoIosEye
                                                  id={`disputeDetailsTooltip${index}`}
                                                  size="27px"
                                                  style={{
                                                    outline: "unset",
                                                    cursor: "pointer",
                                                  }}
                                                  onClick={() =>
                                                    this.toggleTransactionDisputeDetailsModal(
                                                      subscription.disputeDetails,
                                                      subscription._id
                                                    )
                                                  }
                                                  onMouseOver={() =>
                                                    this.setState({
                                                      disputeDetailsSelectedIndex: index,
                                                      disputeDetailsTooltip: true,
                                                    })
                                                  }
                                                  onMouseOut={() =>
                                                    this.setState({
                                                      disputeDetailsSelectedIndex: null,
                                                      disputeDetailsTooltip: false,
                                                    })
                                                  }
                                                />
                                                <Tooltip
                                                  placement="bottom"
                                                  isOpen={
                                                    this.state
                                                      .disputeDetailsTooltip &&
                                                    this.state
                                                      .disputeDetailsSelectedIndex ===
                                                      index
                                                  }
                                                  target={`disputeDetailsTooltip${index}`}
                                                  toggle={() => {}}
                                                >
                                                  View Dispute Details
                                                </Tooltip>
                                              </div>
                                            ) : (
                                              <>
                                                <IoIosEye
                                                  id={`disputeDetailsTooltip${index}`}
                                                  size="27px"
                                                  style={{
                                                    outline: "unset",
                                                    cursor: "pointer",
                                                  }}
                                                  onClick={() =>
                                                    this.toggleTransactionDisputeDetailsModal(
                                                      subscription.disputeDetails,
                                                      subscription._id
                                                    )
                                                  }
                                                  onMouseOver={() =>
                                                    this.setState({
                                                      disputeDetailsSelectedIndex: index,
                                                      disputeDetailsTooltip: true,
                                                    })
                                                  }
                                                  onMouseOut={() =>
                                                    this.setState({
                                                      disputeDetailsSelectedIndex: null,
                                                      disputeDetailsTooltip: false,
                                                    })
                                                  }
                                                />
                                                <Tooltip
                                                  placement="bottom"
                                                  isOpen={
                                                    this.state
                                                      .disputeDetailsTooltip &&
                                                    this.state
                                                      .disputeDetailsSelectedIndex ===
                                                      index
                                                  }
                                                  target={`disputeDetailsTooltip${index}`}
                                                  toggle={() => {}}
                                                >
                                                  View Dispute Details
                                                </Tooltip>
                                              </>
                                            )}
                                          </td>
                                          <td>
                                            {moment
                                              .utc(subscription.dueDate)
                                              .format("LL")}
                                          </td>
                                          <td>
                                            ${" "}
                                            {subscription.price
                                              ? subscription.price.toFixed(2)
                                              : "0.00"}
                                          </td>
                                          <td>
                                            {/* {this.renderDiscountPrice(
                                              "subscriptions",
                                              subscription
                                            )} */}
                                            ${" "}
                                            {subscription.teamDiscountAmount
                                              ? subscription.teamDiscountAmount.toFixed(
                                                  2
                                                )
                                              : "0.00"}
                                          </td>
                                          <td>
                                            ${" "}
                                            {subscription.creditAmount
                                              ? subscription.creditAmount.toFixed(
                                                  2
                                                )
                                              : "0.00"}
                                          </td>
                                          <td>
                                            ${" "}
                                            {subscription.dueAmount
                                              ? subscription.dueAmount.toFixed(
                                                  2
                                                )
                                              : "0.00"}
                                          </td>
                                          <td>
                                            ${" "}
                                            {subscription.totalPrice
                                              ? subscription.totalPrice.toFixed(
                                                  2
                                                )
                                              : "0.00"}
                                          </td>
                                          <td>
                                            ${" "}
                                            {subscription.processingFeesType &&
                                            subscription.processingFeesType ===
                                              "includeProcessingFees"
                                              ? subscription.application_fee_amount.toFixed(
                                                  2
                                                )
                                              : subscription.processingFee.toFixed(
                                                  2
                                                )}
                                          </td>
                                          <td>
                                            ${" "}
                                            {subscription.processingFeesType &&
                                            subscription.processingFeesType ===
                                              "includeProcessingFees"
                                              ? Number(
                                                  subscription.totalPrice -
                                                    subscription.application_fee_amount
                                                ).toFixed(2)
                                              : Number(
                                                  subscription.totalPrice -
                                                    subscription.processingFee
                                                ).toFixed(2)}
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            {subscription.paymentStatus &&
                                            subscription.paymentStatus ===
                                              "pending" ? (
                                              "-"
                                            ) : subscription.paymentStatus ===
                                              "invalid" ? (
                                              <BsExclamationTriangleFill
                                                size="20px"
                                                style={{ color: "#ffc107" }}
                                              ></BsExclamationTriangleFill>
                                            ) : subscription.paymentStatus ===
                                              "paid" ? (
                                              <ImCheckmark
                                                size="20px"
                                                style={{ color: "green" }}
                                              ></ImCheckmark>
                                            ) : (
                                              <ImCross
                                                size="20px"
                                                style={{ color: "red" }}
                                              ></ImCross>
                                            )}
                                          </td>
                                          <td>
                                            {subscription.paidOn
                                              ? moment
                                                  .utc(subscription.paidOn)
                                                  .format("LL")
                                              : "-"}
                                          </td>
                                          <td>
                                            {subscription.paidOn ? (
                                              this.renderRefundButton(
                                                subscription,
                                                "subscription",
                                                index
                                              )
                                            ) : (
                                              <div className="d-flex">
                                                <BsPlusCircle
                                                  id={`subscriptionCashPaymentTooltip${index}`}
                                                  size="25px"
                                                  style={{
                                                    outline: "unset",
                                                    cursor: "pointer",
                                                  }}
                                                  onClick={() =>
                                                    this.toggleCashPaymentConfirmationModal(
                                                      subscription._id,
                                                      subscription.price
                                                    )
                                                  }
                                                  onMouseOver={() =>
                                                    this.setState({
                                                      subscriptionSelectedIndex: index,
                                                      subscriptionCashPaymentTooltip: true,
                                                    })
                                                  }
                                                  onMouseOut={() =>
                                                    this.setState({
                                                      subscriptionSelectedIndex: null,
                                                      subscriptionCashPaymentTooltip: false,
                                                    })
                                                  }
                                                ></BsPlusCircle>
                                                <Tooltip
                                                  placement="bottom"
                                                  isOpen={
                                                    this.state
                                                      .subscriptionCashPaymentTooltip &&
                                                    this.state
                                                      .subscriptionSelectedIndex ===
                                                      index
                                                  }
                                                  target={`subscriptionCashPaymentTooltip${index}`}
                                                  toggle={() => {}}
                                                >
                                                  Payment
                                                </Tooltip>
                                                <MdEdit
                                                  id={`subscriptionTransactionEditTooltip${index}`}
                                                  size="25px"
                                                  style={{
                                                    outline: "unset",
                                                    cursor: "pointer",
                                                  }}
                                                  className="ml-2"
                                                  onClick={() =>
                                                    this.toggleSubscriptionModal(
                                                      subscription
                                                    )
                                                  }
                                                  onMouseOver={() =>
                                                    this.setState({
                                                      subscriptionSelectedIndex: index,
                                                      subscriptionTransactionEditTooltip: true,
                                                    })
                                                  }
                                                  onMouseOut={() =>
                                                    this.setState({
                                                      subscriptionSelectedIndex: null,
                                                      subscriptionTransactionEditTooltip: false,
                                                    })
                                                  }
                                                ></MdEdit>
                                                <Tooltip
                                                  placement="bottom"
                                                  isOpen={
                                                    this.state
                                                      .subscriptionTransactionEditTooltip &&
                                                    this.state
                                                      .subscriptionSelectedIndex ===
                                                      index
                                                  }
                                                  target={`subscriptionTransactionEditTooltip${index}`}
                                                  toggle={() => {}}
                                                >
                                                  Transaction Edit
                                                </Tooltip>
                                              </div>
                                            )}
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            {subscription.paymentType
                                              ? capitalizeFirstLetter(
                                                  subscription.paymentType
                                                )
                                              : "-"}
                                          </td>
                                        </tr>
                                      )
                                    )}
                                </tbody>
                              </Table>
                            ) : (
                              //For installment data
                              <Table bordered responsive>
                                <thead>
                                  <tr>
                                    <th>Dispute Raised</th>
                                    <th>Due Date</th>
                                    {this.state.showFields && (
                                      <>
                                        <th>Installment Price</th>
                                        <th>Discount Price</th>
                                        <th>Credit Amount</th>
                                        <th>Due Amount</th>
                                      </>
                                    )}
                                    <th>Amount Paid</th>
                                    <th>Processing Fee</th>
                                    <th>Net Amount</th>
                                    <th>Payment Status</th>
                                    <th>Paid on</th>
                                    <th>Actions</th>
                                    <th>Payment Type</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.transaction
                                    .installmentsCreatedPlans &&
                                    this.state.transaction.installmentsCreatedPlans.map(
                                      (installmentsCreatedPlan, index) => (
                                        <tr key={index}>
                                          <td
                                            style={{
                                              textAlign: "center",
                                            }}
                                          >
                                            {installmentsCreatedPlan.disputeRaised ? (
                                              <div className="d-fex">
                                                <IoMdFlag
                                                  size="27px"
                                                  style={{
                                                    color: "#ff7c00",
                                                  }}
                                                />
                                                <IoIosEye
                                                  id={`disputeDetailsTooltip${index}`}
                                                  size="27px"
                                                  style={{
                                                    outline: "unset",
                                                    cursor: "pointer",
                                                  }}
                                                  onClick={() =>
                                                    this.toggleTransactionDisputeDetailsModal(
                                                      installmentsCreatedPlan.disputeDetails,
                                                      installmentsCreatedPlan._id
                                                    )
                                                  }
                                                  onMouseOver={() =>
                                                    this.setState({
                                                      disputeDetailsSelectedIndex: index,
                                                      disputeDetailsTooltip: true,
                                                    })
                                                  }
                                                  onMouseOut={() =>
                                                    this.setState({
                                                      disputeDetailsSelectedIndex: null,
                                                      disputeDetailsTooltip: false,
                                                    })
                                                  }
                                                />
                                                <Tooltip
                                                  placement="bottom"
                                                  isOpen={
                                                    this.state
                                                      .disputeDetailsTooltip &&
                                                    this.state
                                                      .disputeDetailsSelectedIndex ===
                                                      index
                                                  }
                                                  target={`disputeDetailsTooltip${index}`}
                                                  toggle={() => {}}
                                                >
                                                  View Dispute Details
                                                </Tooltip>
                                              </div>
                                            ) : (
                                              <>
                                                <IoIosEye
                                                  id={`disputeDetailsTooltip${index}`}
                                                  size="27px"
                                                  style={{
                                                    outline: "unset",
                                                    cursor: "pointer",
                                                  }}
                                                  onClick={() =>
                                                    this.toggleTransactionDisputeDetailsModal(
                                                      installmentsCreatedPlan.disputeDetails,
                                                      installmentsCreatedPlan._id
                                                    )
                                                  }
                                                  onMouseOver={() =>
                                                    this.setState({
                                                      disputeDetailsSelectedIndex: index,
                                                      disputeDetailsTooltip: true,
                                                    })
                                                  }
                                                  onMouseOut={() =>
                                                    this.setState({
                                                      disputeDetailsSelectedIndex: null,
                                                      disputeDetailsTooltip: false,
                                                    })
                                                  }
                                                />
                                                <Tooltip
                                                  placement="bottom"
                                                  isOpen={
                                                    this.state
                                                      .disputeDetailsTooltip &&
                                                    this.state
                                                      .disputeDetailsSelectedIndex ===
                                                      index
                                                  }
                                                  target={`disputeDetailsTooltip${index}`}
                                                  toggle={() => {}}
                                                >
                                                  View Dispute Details
                                                </Tooltip>
                                              </>
                                            )}
                                          </td>
                                          <td>
                                            {moment
                                              .utc(
                                                installmentsCreatedPlan.dueDate
                                              )
                                              .format("LL")}
                                          </td>
                                          {this.state.showFields && (
                                            <>
                                              <td>
                                                ${" "}
                                                {installmentsCreatedPlan.campPricePerInstallment
                                                  ? installmentsCreatedPlan.campPricePerInstallment.toFixed(
                                                      2
                                                    )
                                                  : "0.00"}
                                              </td>
                                              <td>
                                                ${" "}
                                                {installmentsCreatedPlan.teamDiscountAmount
                                                  ? installmentsCreatedPlan.teamDiscountAmount.toFixed(
                                                      2
                                                    )
                                                  : "0.00"}
                                              </td>
                                              <td>
                                                ${" "}
                                                {installmentsCreatedPlan.creditAmount
                                                  ? installmentsCreatedPlan.creditAmount.toFixed(
                                                      2
                                                    )
                                                  : "0.00"}
                                              </td>
                                              <td>
                                                ${" "}
                                                {installmentsCreatedPlan.dueAmount
                                                  ? installmentsCreatedPlan.dueAmount.toFixed(
                                                      2
                                                    )
                                                  : "0.00"}
                                              </td>
                                            </>
                                          )}
                                          <td>
                                            ${" "}
                                            {installmentsCreatedPlan.price.toFixed(
                                              2
                                            )}
                                          </td>
                                          <td>
                                            ${" "}
                                            {installmentsCreatedPlan.processingFeesType &&
                                            installmentsCreatedPlan.processingFeesType ===
                                              "includeProcessingFees"
                                              ? installmentsCreatedPlan.application_fee_amount.toFixed(
                                                  2
                                                )
                                              : installmentsCreatedPlan.processingFee.toFixed(
                                                  2
                                                )}
                                          </td>
                                          <td>
                                            ${" "}
                                            {installmentsCreatedPlan.processingFeesType &&
                                            installmentsCreatedPlan.processingFeesType ===
                                              "includeProcessingFees"
                                              ? Number(
                                                  installmentsCreatedPlan.price -
                                                    installmentsCreatedPlan.application_fee_amount
                                                ).toFixed(2)
                                              : Number(
                                                  installmentsCreatedPlan.price -
                                                    installmentsCreatedPlan.processingFee
                                                ).toFixed(2)}
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            {this.renderPaymentStatus(
                                              installmentsCreatedPlan
                                            )}
                                          </td>
                                          <td>
                                            {installmentsCreatedPlan.paidOn
                                              ? moment
                                                  .utc(
                                                    installmentsCreatedPlan.paidOn
                                                  )
                                                  .format("LL")
                                              : "-"}
                                          </td>
                                          <td>
                                            {installmentsCreatedPlan.paidOn ? (
                                              this.renderRefundButton(
                                                installmentsCreatedPlan,
                                                "installment",
                                                index
                                              )
                                            ) : (
                                              <div className="d-flex">
                                                <BsPlusCircle
                                                  id={`installmentCashPaymentTooltip${index}`}
                                                  size="25px"
                                                  style={{
                                                    outline: "unset",
                                                    cursor: "pointer",
                                                  }}
                                                  onClick={() =>
                                                    this.toggleCashPaymentConfirmationModal(
                                                      installmentsCreatedPlan._id,
                                                      installmentsCreatedPlan.campPricePerInstallment
                                                    )
                                                  }
                                                  onMouseOver={() =>
                                                    this.setState({
                                                      installmentSelectedIndex: index,
                                                      installmentCashPaymentTooltip: true,
                                                    })
                                                  }
                                                  onMouseOut={() =>
                                                    this.setState({
                                                      installmentSelectedIndex: null,
                                                      installmentCashPaymentTooltip: false,
                                                    })
                                                  }
                                                ></BsPlusCircle>
                                                <Tooltip
                                                  placement="bottom"
                                                  isOpen={
                                                    this.state
                                                      .installmentCashPaymentTooltip &&
                                                    this.state
                                                      .installmentSelectedIndex ===
                                                      index
                                                  }
                                                  target={`installmentCashPaymentTooltip${index}`}
                                                  toggle={() => {}}
                                                >
                                                  Payment
                                                </Tooltip>
                                                <MdEdit
                                                  id={`installmentTransactionEditTooltip${index}`}
                                                  size="25px"
                                                  style={{
                                                    outline: "unset",
                                                    cursor: "pointer",
                                                  }}
                                                  className="ml-2"
                                                  onClick={() =>
                                                    this.toggleInstallmentUpdateModal(
                                                      installmentsCreatedPlan
                                                    )
                                                  }
                                                  onMouseOver={() =>
                                                    this.setState({
                                                      installmentSelectedIndex: index,
                                                      installmentTransactionEditTooltip: true,
                                                    })
                                                  }
                                                  onMouseOut={() =>
                                                    this.setState({
                                                      installmentSelectedIndex: null,
                                                      installmentTransactionEditTooltip: false,
                                                    })
                                                  }
                                                ></MdEdit>
                                                <Tooltip
                                                  placement="bottom"
                                                  isOpen={
                                                    this.state
                                                      .installmentTransactionEditTooltip &&
                                                    this.state
                                                      .installmentSelectedIndex ===
                                                      index
                                                  }
                                                  target={`installmentTransactionEditTooltip${index}`}
                                                  toggle={() => {}}
                                                >
                                                  Transaction Edit
                                                </Tooltip>
                                              </div>
                                            )}
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            {this.renderPaymentType(
                                              installmentsCreatedPlan
                                            )}
                                          </td>
                                        </tr>
                                      )
                                    )}
                                </tbody>
                              </Table>
                            )}
                          </Card>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              <Col style={{ padding: 0 }}>
                <Card className="mb-3 mt-3">
                  <CardHeader>Transaction History</CardHeader>
                  <CardBody>
                    <Row>
                      <Col>
                        <Card body>
                          {this.state.transaction.interval === "onetime" ? (
                            <Table bordered responsive>
                              <thead>
                                <tr>
                                  <th>Date</th>
                                  <th>Transaction</th>
                                  <th>Note</th>
                                  <th>Payment Status</th>
                                  <th>Payment Type</th>
                                  <th>Amount</th>
                                  <th>View Receipt</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>
                                    {moment
                                      .utc(this.state.transaction.createdAt)
                                      .format("LL")}
                                  </td>
                                  <td>
                                    Transaction {this.state.transaction._id} ·{" "}
                                    {this.state.transaction.status.toUpperCase()}{" "}
                                    · Payment Intent Id:{" "}
                                    {this.state.transaction.data.id
                                      ? this.state.transaction.data.id
                                      : "-"}
                                  </td>
                                  <td>
                                    {this.state.transaction.note
                                      ? capitalizeFirstLetter(
                                          this.state.transaction.note
                                        )
                                      : "-"}
                                  </td>
                                  <td>
                                    {this.state.transaction &&
                                      capitalizeFirstLetter(
                                        this.state.transaction.status
                                      )}
                                  </td>
                                  <td>
                                    {this.state.transaction.paymentType
                                      ? this.state.transaction.paymentType ===
                                        "bank_debit"
                                        ? "Ach_debit"
                                        : capitalizeFirstLetter(
                                            this.state.transaction.paymentType
                                          )
                                      : "-"}
                                  </td>
                                  <td>
                                    $ {this.state.transaction.price.toFixed(2)}
                                  </td>
                                  <td>
                                    <a
                                      href={
                                        this.state.transaction.data.receipt_url
                                          ? this.state.transaction.data
                                              .receipt_url
                                          : this.state.transaction.data.charges
                                          ? this.state.transaction.data.charges
                                              .data[0].receipt_url
                                          : "https://zocial.io/noReceipt.html"
                                      }
                                      target="_blank"
                                    >
                                      View
                                    </a>
                                  </td>
                                </tr>
                              </tbody>
                            </Table>
                          ) : this.state.transaction.interval ===
                            "monthly subscription" ? (
                            <Table bordered responsive>
                              <thead>
                                <tr>
                                  <th>Date</th>
                                  <th>Transaction</th>
                                  <th>Note</th>
                                  <th>Payment Status</th>
                                  <th>Payment Type</th>
                                  <th>Amount</th>
                                  <th>View Receipt</th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.state.transaction.subscriptions &&
                                  this.state.transaction.subscriptions.map(
                                    (subscription, index) => (
                                      <tr key={index}>
                                        <td>
                                          {subscription.paidOn
                                            ? moment
                                                .utc(subscription.paidOn)
                                                .format("LL")
                                            : moment
                                                .utc(subscription.dueDate)
                                                .format("LL")}
                                        </td>
                                        <td>Transaction {subscription._id}</td>
                                        <td>
                                          {subscription.note
                                            ? capitalizeFirstLetter(
                                                subscription.note
                                              )
                                            : "-"}
                                        </td>
                                        <td>
                                          {subscription.paymentStatus.toUpperCase()}
                                        </td>
                                        <td>
                                          {subscription.paymentType
                                            ? capitalizeFirstLetter(
                                                subscription.paymentType
                                              )
                                            : "-"}
                                        </td>
                                        <td>
                                          ${" "}
                                          {subscription.totalPrice
                                            ? subscription.totalPrice.toFixed(2)
                                            : "0.00"}
                                        </td>
                                        <td>
                                          {subscription.hosted_invoice_url ? (
                                            <a
                                              href={
                                                subscription.hosted_invoice_url
                                              }
                                              target="_blank"
                                            >
                                              View
                                            </a>
                                          ) : (
                                            "-"
                                          )}
                                        </td>
                                      </tr>
                                    )
                                  )}
                              </tbody>
                            </Table>
                          ) : (
                            <Table bordered responsive>
                              <thead>
                                <tr>
                                  <th>Date</th>
                                  <th>Transaction</th>
                                  <th>Note</th>
                                  <th>Payment Status</th>
                                  <th>Payment Type</th>
                                  <th>Amount</th>
                                  <th>View Receipt</th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.state.transaction.installmentsPaid &&
                                  this.state.transaction.installmentsPaid.map(
                                    (installmentPaid, index) => (
                                      <tr key={index}>
                                        <td>
                                          {moment
                                            .utc(installmentPaid.paidOn)
                                            .format("LL")}
                                        </td>
                                        <td>
                                          Installment Number :{" "}
                                          {installmentPaid.installmentNumber} ·{" "}
                                          Installment Id : {installmentPaid._id}{" "}
                                          ·{" "}
                                          {installmentPaid.paymentStatus.toUpperCase()}{" "}
                                        </td>
                                        <td>
                                          {installmentPaid.note
                                            ? capitalizeFirstLetter(
                                                installmentPaid.note
                                              )
                                            : "-"}
                                        </td>
                                        <td>
                                          {capitalizeFirstLetter(
                                            installmentPaid.paymentStatus
                                          )}
                                        </td>
                                        <td>
                                          {capitalizeFirstLetter(
                                            installmentPaid.paymentType
                                          )}
                                        </td>
                                        <td>$ {installmentPaid.price}</td>
                                        <td>
                                          <a
                                            href={
                                              installmentPaid.hosted_invoice_url
                                            }
                                            target="_blank"
                                          >
                                            View
                                          </a>
                                        </td>
                                      </tr>
                                    )
                                  )}
                              </tbody>
                            </Table>
                          )}
                          <Row>
                            <Col sm={12} md={12} lg={12} xl={12}>
                              <div className="d-flex justify-content-center">
                                <Button onClick={this.props.history.goBack}>
                                  Cancel
                                </Button>
                              </div>
                            </Col>
                          </Row>
                        </Card>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Col>
          </Row>
          {this.state.confirmationModal ? (
            <Modal
              isOpen={this.state.confirmationModal}
              toggle={(event) => this.toggleConfirmationModal()}
              className="modal-md"
            >
              <ModalHeader
                toggle={(event) => this.toggleConfirmationModal()}
              ></ModalHeader>
              <ModalBody>
                Are you sure you want to
                {this.state.cancelSubscription
                  ? " Cancel Subscription?"
                  : " Initiate Refund?"}{" "}
              </ModalBody>
              <ModalFooter>
                <Button
                  color="secondary"
                  onClick={(event) => this.toggleConfirmationModal()}
                >
                  Cancel
                </Button>{" "}
                <Button
                  color="primary"
                  onClick={(event) => {
                    this.toggleConfirmationModal();
                    this.issueRefund(event);
                  }}
                >
                  {this.state.cancelSubscription
                    ? "Cancel Subscription "
                    : "Initiate Refund"}
                </Button>
              </ModalFooter>
            </Modal>
          ) : null}
          {this.state.paymentConfirmationModal ? (
            <Modal
              isOpen={this.state.paymentConfirmationModal}
              toggle={(event) => this.togglePaymentConfirmationModal()}
              className="modal-md"
            >
              <ModalHeader
                toggle={(event) => this.togglePaymentConfirmationModal()}
              >
                {this.state.transaction.pausePayment
                  ? "Resume payment"
                  : "Pause payment"}
              </ModalHeader>
              <ModalBody>
                {this.state.transaction.pausePayment ? (
                  "Are you sure you want to resume payment ?"
                ) : (
                  <Table responsive className="mb-0">
                    <tbody>
                      <tr>
                        <td colSpan="2">
                          Are you sure you want to pause payment ?
                        </td>
                      </tr>
                      <tr>
                        <td style={{ verticalAlign: "middle" }}>
                          Select resume payment date
                        </td>
                        <td>
                          <Input
                            type="date"
                            value={
                              moment
                                .utc(new Date(this.state.resumePaymentDate))
                                .format("YYYY-MM-DD") || ""
                            }
                            onChange={(event) =>
                              this.setState({
                                resumePaymentDate: new Date(
                                  event.target.value
                                ).setUTCHours(12),
                              })
                            }
                          ></Input>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                )}
              </ModalBody>
              <ModalFooter>
                <Button
                  color="secondary"
                  onClick={(event) => this.togglePaymentConfirmationModal()}
                >
                  Cancel
                </Button>{" "}
                <Button
                  color="primary"
                  onClick={(event) => {
                    this.updatePayment();
                    this.togglePaymentConfirmationModal();
                  }}
                >
                  Submit
                </Button>
              </ModalFooter>
            </Modal>
          ) : null}
          {this.state.cashPaymentConfirmationModal ? (
            <Modal
              isOpen={this.state.cashPaymentConfirmationModal}
              toggle={(event) => this.toggleCashPaymentConfirmationModal()}
              className="modal-md"
            >
              <ModalHeader
                toggle={(event) => this.toggleCashPaymentConfirmationModal()}
              >
                Payment
              </ModalHeader>
              <ModalBody>
                <Row>
                  <Col xl={12} lg={12} md={12}>
                    <FormGroup>
                      <Label>Select Option</Label>
                      <Select
                        options={this.state.options}
                        placeholder="Select the value"
                        value={this.state.selectedOption}
                        onChange={(result) =>
                          this.setState({
                            selectedOption: result,
                            fullPayment: true,
                          })
                        }
                        className="basic-single"
                        classNamePrefix="select"
                      />
                    </FormGroup>
                  </Col>
                </Row>
                {/* {this.state.selectedOption.value === "cash" ? ( */}
                <Row>
                  <Col xl={6} lg={6} md={6} sm={6}>
                    <FormGroup>
                      <CustomInput
                        id="fullpayment"
                        type="radio"
                        label="Full Amount"
                        checked={this.state.fullPayment}
                        name="payment"
                        onClick={() =>
                          this.setState({
                            price: this.state.maxPrice,
                            fullPayment: true,
                          })
                        }
                      />
                    </FormGroup>
                  </Col>
                  <Col xl={6} lg={6} md={6} sm={6}>
                    <FormGroup>
                      <CustomInput
                        id="partialAmount"
                        type="radio"
                        label="Partial Amount"
                        checked={!this.state.fullPayment}
                        name="payment"
                        onClick={() =>
                          this.setState({
                            fullPayment: false,
                          })
                        }
                      />
                    </FormGroup>
                  </Col>
                </Row>
                {/* ) : null} */}
                {/* {this.state.selectedOption.value === "other" ? ( */}
                <Row>
                  <Col xl={12} lg={12} md={12}>
                    <FormGroup>
                      <Label>Note</Label>
                      <Input
                        type="text"
                        placeholder="Enter the note"
                        value={this.state.optionNote}
                        onChange={(event) =>
                          this.setState({
                            optionNote: event.target.value,
                          })
                        }
                      ></Input>
                    </FormGroup>
                  </Col>
                </Row>
                {/* ) : null} */}
                <Row>
                  <Col xl={12} lg={12} md={12}>
                    <FormGroup>
                      <Label>Amount</Label>
                      <Input
                        disabled={this.state.fullPayment}
                        required
                        type="number"
                        placeholder="Amount"
                        min="0"
                        max={this.state.maxPrice}
                        value={this.state.price}
                        onChange={(event) =>
                          this.setState({
                            price: event.target.value,
                          })
                        }
                      ></Input>
                    </FormGroup>
                  </Col>
                </Row>
              </ModalBody>
              <ModalFooter>
                <Button
                  color="secondary"
                  onClick={(event) => this.toggleCashPaymentConfirmationModal()}
                >
                  Cancel
                </Button>{" "}
                <Button
                  color="primary"
                  onClick={(event) => {
                    this.cashPayment();
                  }}
                >
                  Pay
                </Button>
              </ModalFooter>
            </Modal>
          ) : null}
          {this.state.refundConfirmationModal ? (
            <Modal
              isOpen={this.state.refundConfirmationModal}
              toggle={(event) => this.toggleRefundConfirmationModal()}
              className="modal-md"
            >
              <ModalHeader
                toggle={(event) => this.toggleRefundConfirmationModal()}
              >
                Are you sure you want to Initiate Refund?
              </ModalHeader>
              <ModalBody>
                <Row>
                  <Col xl={12} lg={12} md={12}>
                    <FormGroup>
                      <Label>Refund Amount</Label>
                      <Input
                        required
                        type="number"
                        placeholder="Amount"
                        min="0"
                        max={this.state.maxPrice}
                        value={this.state.refundAmount}
                        onChange={(event) =>
                          this.setState({
                            refundAmount:
                              event.target.value > this.state.maxPrice
                                ? this.state.maxPrice
                                : event.target.value,
                          })
                        }
                      ></Input>
                    </FormGroup>
                  </Col>
                </Row>
              </ModalBody>
              <ModalFooter>
                <Button
                  color="secondary"
                  onClick={(event) => this.toggleRefundConfirmationModal()}
                >
                  Cancel
                </Button>{" "}
                <Button
                  color="primary"
                  onClick={(event) => {
                    this.toggleRefundConfirmationModal();
                    this.issueRefund(event);
                  }}
                >
                  Initiate Refund
                </Button>
              </ModalFooter>
            </Modal>
          ) : null}
          {this.state.reprocessConfirmationModal ? (
            <Modal
              isOpen={this.state.reprocessConfirmationModal}
              toggle={(event) => this.toggleReprocessConfirmationModal()}
              className="modal-md"
            >
              <ModalHeader
                toggle={(event) => this.toggleReprocessConfirmationModal()}
              >
                Are you sure you want to Reprocess?
              </ModalHeader>
              {this.state.reprocessTransactionPaymentType === "card" ? (
                <ModalBody>
                  <Row>
                    <Col xl={12} lg={12} md={12}>
                      <FormGroup>
                        <Label>Select Credit Card</Label>
                        <Select
                          placeholder="Select the credit card"
                          value={this.state.selectedCreditCard}
                          options={this.state.allCreditCardOptions}
                          onChange={(result) =>
                            this.setState({
                              selectedCreditCard: result,
                            })
                          }
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </ModalBody>
              ) : null}
              <ModalFooter>
                <Button
                  color="secondary"
                  onClick={(event) => this.toggleReprocessConfirmationModal()}
                >
                  Cancel
                </Button>{" "}
                <Button
                  color="primary"
                  onClick={(event) => {
                    this.reprocessTransactions();
                  }}
                >
                  Reprocess
                </Button>
              </ModalFooter>
            </Modal>
          ) : null}
          {this.state.reprocessDataConfirmationModal ? (
            <Modal
              isOpen={this.state.reprocessDataConfirmationModal}
              toggle={(event) => this.toggleReprocessDataConfirmationModal()}
              className="modal-md"
            >
              <ModalHeader
                toggle={(event) => this.toggleReprocessDataConfirmationModal()}
              >
                Reprocess Data
              </ModalHeader>
              <ModalBody>
                {this.state.reprocessTransactionData.length !== 3 ? (
                  <Table striped hover responsive>
                    <thead>
                      <tr>
                        <th style={{ width: "50%", textAlign: "center" }}>
                          Next Reprocess date
                        </th>
                        <th>
                          {this.state.updateReprocessDate ? (
                            <div className="d-flex">
                              <Input
                                type="date"
                                value={
                                  moment
                                    .utc(
                                      new Date(
                                        this.state.reprocessTransactionDate
                                      )
                                    )
                                    .format("YYYY-MM-DD") || ""
                                }
                                onChange={(event) =>
                                  this.setState({
                                    reprocessTransactionDate: new Date(
                                      event.target.value
                                    ).setUTCHours(12),
                                  })
                                }
                              ></Input>
                              <BsCheck
                                size="30px"
                                style={{
                                  outline: "unset",
                                  cursor: "pointer",
                                  margin: "auto 0px",
                                }}
                                className="ml-2"
                                onClick={() => this.updateReprocessDate()}
                              ></BsCheck>
                              <MdClose
                                size="30px"
                                style={{
                                  outline: "unset",
                                  cursor: "pointer",
                                  margin: "auto 0px",
                                }}
                                className="ml-2"
                                onClick={(event) =>
                                  this.setState({
                                    updateReprocessDate: !this.state
                                      .updateReprocessDate,
                                  })
                                }
                              ></MdClose>
                            </div>
                          ) : (
                            <div className="d-flex">
                              {this.state.reprocessTransactionDate
                                ? moment
                                    .utc(this.state.reprocessTransactionDate)
                                    .format("LL")
                                : "-"}
                              <MdEdit
                                size="20px"
                                style={{
                                  outline: "unset",
                                  cursor: "pointer",
                                }}
                                className="ml-2"
                                onClick={(event) =>
                                  this.setState({
                                    updateReprocessDate: !this.state
                                      .updateReprocessDate,
                                  })
                                }
                              ></MdEdit>
                            </div>
                          )}
                        </th>
                      </tr>
                    </thead>
                  </Table>
                ) : null}
                <Table responsive>
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Date</th>
                      <th>Note</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.reprocessTransactionData.length ? (
                      this.state.reprocessTransactionData.map((data, index) => (
                        <tr>
                          <td>{index + 1}</td>
                          <td>
                            {data.date
                              ? moment.utc(data.date).format("LL")
                              : "-"}
                          </td>
                          <td>
                            {data.note ? capitalizeFirstLetter(data.note) : "-"}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan="4"
                          className="text-center"
                          style={{ background: "#dee2e6" }}
                        >
                          Reprocess data not found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </ModalBody>
              <ModalFooter>
                <Button
                  color="secondary"
                  onClick={(event) =>
                    this.toggleReprocessDataConfirmationModal()
                  }
                >
                  Cancel
                </Button>{" "}
              </ModalFooter>
            </Modal>
          ) : null}
          {this.state.addInstallmentModal ? (
            <Modal
              isOpen={this.state.addInstallmentModal}
              toggle={(event) => this.toggleInstallmentModal()}
              className="modal-md"
            >
              <ModalHeader toggle={(event) => this.toggleInstallmentModal()}>
                Installments
              </ModalHeader>
              <ModalBody>
                <BsDashCircle
                  size="25px"
                  style={{
                    margin: "10px",
                    marginTop: "0px",
                    float: "right",
                    outline: "unset",
                    cursor: "pointer",
                  }}
                  onClick={this.removeInstallment}
                ></BsDashCircle>
                <BsPlusCircle
                  size="25px"
                  style={{
                    margin: "10px",
                    marginTop: "0px",
                    float: "right",
                    outline: "unset",
                    cursor: "pointer",
                  }}
                  onClick={this.addInstallment}
                ></BsPlusCircle>
                <Table responsive>
                  <thead>
                    <tr>
                      <th>Number</th>
                      <th>Price</th>
                      <th>Due Date</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.tempInstallmentsCreatedPlans &&
                    this.state.tempInstallmentsCreatedPlans.length ? (
                      this.state.tempInstallmentsCreatedPlans.map(
                        (value, index) => (
                          <tr key={index}>
                            <td>{value.installmentNumber}</td>
                            <td>{Number(value.price).toFixed(2)}</td>
                            {this.getInstallmentPaymentStatus(
                              value.installmentNumber
                            ).toLowerCase() === "unpaid" ? (
                              <td>
                                <Input
                                  type="date"
                                  value={
                                    moment
                                      .utc(new Date(value.dueDate))
                                      .format("YYYY-MM-DD") || ""
                                  }
                                  onChange={(event) => {
                                    let installments = cloneDeep(
                                      this.state.tempInstallmentsCreatedPlans
                                    );
                                    let date = new Date(
                                      event.target.value
                                    ).setUTCHours(12);
                                    installments[index].dueDate = date;
                                    this.setState({
                                      tempInstallmentsCreatedPlans: installments,
                                    });
                                  }}
                                ></Input>
                              </td>
                            ) : (
                              <td>{moment.utc(value.dueDate).format("LL")}</td>
                            )}
                            <td>
                              {capitalizeFirstLetter(
                                this.getInstallmentPaymentStatus(
                                  value.installmentNumber
                                )
                              )}
                            </td>
                          </tr>
                        )
                      )
                    ) : (
                      <tr>
                        <td
                          colSpan="4"
                          className="text-center"
                          style={{ background: "#dee2e6" }}
                        >
                          Installments not found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </ModalBody>
              <ModalFooter>
                <Button
                  color="secondary"
                  onClick={() => this.toggleInstallmentModal()}
                >
                  Cancel
                </Button>{" "}
                <Button
                  color="primary"
                  onClick={() => {
                    this.toggleInstallmentModal();
                    this.updateTransaction("installment");
                  }}
                >
                  Update Installment
                </Button>
              </ModalFooter>
            </Modal>
          ) : null}
          {this.state.subscriptionUpdateModal ? (
            <Modal
              isOpen={this.state.subscriptionUpdateModal}
              toggle={(event) => this.toggleSubscriptionModal()}
              className="modal-md"
            >
              <ModalHeader toggle={(event) => this.toggleSubscriptionModal()}>
                Subscriptions
              </ModalHeader>
              <ModalBody>
                <Table responsive className="mb-0">
                  <tbody>
                    <tr>
                      <td style={{ verticalAlign: "middle" }}>
                        Subscription Due Date
                      </td>
                      <td>
                        <Input
                          type="date"
                          value={
                            moment
                              .utc(new Date(this.state.subscriptionDate))
                              .format("YYYY-MM-DD") || ""
                          }
                          onChange={(event) =>
                            this.setState({
                              subscriptionDate: new Date(
                                event.target.value
                              ).setUTCHours(12),
                            })
                          }
                        ></Input>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ verticalAlign: "middle" }}>
                        Subscription Price
                      </td>
                      <td>
                        <Input
                          type="number"
                          min="0"
                          value={this.state.price}
                          onChange={(event) =>
                            this.updateTransactionAmount(
                              event.target.value,
                              "subscription"
                            )
                          }
                        ></Input>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ verticalAlign: "middle" }}>
                        Processing Fee
                      </td>
                      <td>
                        <Input
                          type="number"
                          disabled
                          value={this.state.processingFee}
                        ></Input>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ verticalAlign: "middle" }}>Amount Paid</td>
                      <td>
                        <Input
                          type="number"
                          disabled
                          value={this.state.totalPrice}
                        ></Input>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </ModalBody>
              <ModalFooter>
                <Button
                  color="secondary"
                  onClick={() => this.toggleSubscriptionModal()}
                >
                  Cancel
                </Button>{" "}
                <Button
                  color="primary"
                  onClick={() => {
                    this.toggleSubscriptionModal();
                    this.updateTransaction("subscription");
                  }}
                >
                  Update Subscription
                </Button>
              </ModalFooter>
            </Modal>
          ) : null}
          {this.state.installmentUpdateModal ? (
            <Modal
              isOpen={this.state.installmentUpdateModal}
              toggle={(event) => this.toggleInstallmentUpdateModal()}
              className="modal-md"
            >
              <ModalHeader
                toggle={(event) => this.toggleInstallmentUpdateModal()}
              >
                Installments
              </ModalHeader>
              <ModalBody>
                <Table responsive className="mb-0">
                  <tbody>
                    <tr>
                      <td style={{ verticalAlign: "middle" }}>
                        Installment Due Date
                      </td>
                      <td>
                        <Input
                          type="date"
                          value={
                            moment
                              .utc(new Date(this.state.installmentDate))
                              .format("YYYY-MM-DD") || ""
                          }
                          onChange={(event) =>
                            this.setState({
                              installmentDate: new Date(
                                event.target.value
                              ).setUTCHours(12),
                            })
                          }
                        ></Input>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ verticalAlign: "middle" }}>
                        Installment Price
                      </td>
                      <td>
                        <Input
                          type="number"
                          min="0"
                          value={this.state.price}
                          onChange={(event) =>
                            this.updateTransactionAmount(
                              event.target.value,
                              "installment"
                            )
                          }
                        ></Input>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ verticalAlign: "middle" }}>
                        Processing Fee
                      </td>
                      <td>
                        <Input
                          type="number"
                          disabled
                          value={this.state.processingFee}
                        ></Input>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ verticalAlign: "middle" }}>Amount Paid</td>
                      <td>
                        <Input
                          type="number"
                          disabled
                          value={this.state.totalPrice}
                        ></Input>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </ModalBody>
              <ModalFooter>
                <Button
                  color="secondary"
                  onClick={() => this.toggleInstallmentUpdateModal()}
                >
                  Cancel
                </Button>{" "}
                <Button
                  color="primary"
                  onClick={() => {
                    this.toggleInstallmentUpdateModal();
                    this.updateTransaction("updateSingleInstallment");
                  }}
                >
                  Update Installment
                </Button>
              </ModalFooter>
            </Modal>
          ) : null}
          {this.state.updateCreditCardModal ? (
            <Modal
              isOpen={this.state.updateCreditCardModal}
              toggle={(event) => this.toggleUpdateCreditCardModal()}
              className="modal-md"
            >
              <ModalHeader
                toggle={(event) => this.toggleUpdateCreditCardModal()}
              >
                Update Credit Card
              </ModalHeader>
              <ModalBody>
                <Row>
                  <Col xl={12} lg={12} md={12}>
                    <FormGroup>
                      <Label>Selected credit card for payment </Label>
                      <Input
                        disabled
                        value={
                          this.state.selectedCreditCardForPayment.label || "-"
                        }
                      ></Input>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col xl={12} lg={12} md={12}>
                    <FormGroup>
                      <Label>Select Credit Card</Label>
                      <Select
                        placeholder="Select the credit card"
                        value={this.state.selectedCreditCard}
                        options={this.state.allCreditCardOptions}
                        onChange={(result) =>
                          this.setState({
                            selectedCreditCard: result,
                          })
                        }
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </ModalBody>
              <ModalFooter>
                <Button
                  color="secondary"
                  onClick={() => this.toggleUpdateCreditCardModal()}
                >
                  Cancel
                </Button>{" "}
                <Button
                  color="primary"
                  onClick={() => {
                    this.updateCreditCard();
                  }}
                >
                  Update Credit Card
                </Button>
              </ModalFooter>
            </Modal>
          ) : null}
          {this.state.disputeResolveModal ? (
            <Modal
              isOpen={this.state.disputeResolveModal}
              toggle={(event) => this.toggleDisputeResolveModalModal()}
              className="modal-md"
            >
              <ModalHeader
                toggle={(event) => this.toggleDisputeResolveModalModal()}
              >
                Are you sure you want to resolve dispute?
              </ModalHeader>
              <ModalBody>
                <Row>
                  <Col xl={12} lg={12} md={12}>
                    <FormGroup>
                      <Label>Note</Label>
                      <Input
                        type="text"
                        placeholder="Enter the note"
                        value={this.state.disputeResolvedNote}
                        onChange={(event) =>
                          this.setState({
                            disputeResolvedNote: event.target.value,
                          })
                        }
                      ></Input>
                    </FormGroup>
                  </Col>
                </Row>
              </ModalBody>
              <ModalFooter>
                <Button
                  color="secondary"
                  onClick={() => this.toggleDisputeResolveModalModal()}
                >
                  Cancel
                </Button>{" "}
                <Button
                  color="primary"
                  onClick={() => {
                    this.resolveDispute();
                  }}
                >
                  Resolve
                </Button>
              </ModalFooter>
            </Modal>
          ) : null}
          {this.state.transactionDisputeDetailsModal ? (
            <Modal
              isOpen={this.state.transactionDisputeDetailsModal}
              toggle={(event) => this.toggleTransactionDisputeDetailsModal()}
              className="modal-lg"
            >
              <ModalHeader
                toggle={(event) => this.toggleTransactionDisputeDetailsModal()}
              >
                Transaction Dispute Details
              </ModalHeader>
              <ModalBody>
                <Table striped hover responsive>
                  <thead>
                    <tr>
                      <th>Dispute</th>
                      <th>Dispute Raised Date</th>
                      <th>Title</th>
                      <th>Description</th>
                      <th>Dispute Resolved Date</th>
                      <th>Dispute Resolved Note</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.transactionDisputeDetails.length ? (
                      this.state.transactionDisputeDetails.map(
                        (data, index) => (
                          <tr key={index}>
                            <td>
                              {data.dispute
                                ? capitalizeFirstLetter(data.dispute)
                                : "-"}
                            </td>
                            <td>
                              {data.disputeRaisedDate
                                ? moment
                                    .utc(data.disputeRaisedDate)
                                    .format("LL")
                                : "-"}
                            </td>
                            <td>
                              {data.title
                                ? capitalizeFirstLetter(data.title)
                                : "-"}
                            </td>
                            <td>
                              {data.description
                                ? capitalizeFirstLetter(data.description)
                                : "-"}
                            </td>
                            <td>
                              {data.disputeResolvedDate
                                ? moment
                                    .utc(data.disputeResolvedDate)
                                    .format("LL")
                                : "-"}
                            </td>
                            <td>
                              {data.disputeResolvedNote
                                ? capitalizeFirstLetter(
                                    data.disputeResolvedNote
                                  )
                                : "-"}
                            </td>
                            <td>
                              {data.disputeRaised ? (
                                <>
                                  <BsPlusCircle
                                    id={`disputeTooltip${index}`}
                                    size="27px"
                                    style={{
                                      outline: "unset",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      this.toggleDisputeResolveModalModal(
                                        data._id
                                      )
                                    }
                                    onMouseOver={() =>
                                      this.setState({
                                        disputeSelectedIndex: index,
                                        disputeTooltip: true,
                                      })
                                    }
                                    onMouseOut={() =>
                                      this.setState({
                                        disputeSelectedIndex: null,
                                        disputeTooltip: false,
                                      })
                                    }
                                  />
                                  <Tooltip
                                    placement="bottom"
                                    isOpen={
                                      this.state.disputeTooltip &&
                                      this.state.disputeSelectedIndex === index
                                    }
                                    target={`disputeTooltip${index}`}
                                    toggle={() => {}}
                                  >
                                    Resolve dispute
                                  </Tooltip>
                                </>
                              ) : (
                                "-"
                              )}
                            </td>
                          </tr>
                        )
                      )
                    ) : (
                      <tr>
                        <td
                          colSpan="7"
                          className="text-center"
                          style={{ background: "#dee2e6" }}
                        >
                          Transaction dispute details data not found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </ModalBody>
              <ModalFooter>
                <Button
                  color="secondary"
                  onClick={() => this.toggleTransactionDisputeDetailsModal()}
                >
                  Cancel
                </Button>{" "}
              </ModalFooter>
            </Modal>
          ) : null}
          {this.state.sendNotificaitonModal ? (
            <Modal
              isOpen={this.state.sendNotificaitonModal}
              toggle={(event) => this.toggleSendNotificaitonModal()}
              className="modal-md"
            >
              <ModalHeader
                toggle={(event) => this.toggleSendNotificaitonModal()}
              >
                Are you sure you want to send notificaiton?
              </ModalHeader>
              <Form onSubmit={(event) => this.sendNotificaitonToPlayer(event)}>
                <ModalBody>
                  <Row>
                    <Col xl={12} lg={12} md={12}>
                      <FormGroup>
                        <Label>Note</Label>
                        <Input
                          required
                          type="text"
                          placeholder="Enter the note"
                          value={this.state.sendNotificaitonMessage}
                          onChange={(event) =>
                            this.setState({
                              sendNotificaitonMessage: event.target.value,
                            })
                          }
                        ></Input>
                      </FormGroup>
                    </Col>
                  </Row>
                </ModalBody>
                <ModalFooter>
                  <Button
                    color="secondary"
                    onClick={() => this.toggleSendNotificaitonModal()}
                  >
                    Cancel
                  </Button>{" "}
                  <Button color="primary" type="submit">
                    Send Notification
                  </Button>
                </ModalFooter>
              </Form>
            </Modal>
          ) : null}
          <NotificationSystem
            dismissible={false}
            ref={(notificationSystem) =>
              (this.notificationSystem = notificationSystem)
            }
            style={NOTIFICATION_SYSTEM_STYLE}
          />
        </Page>
      </div>
    );
  }
}
export default PlayerPaymentDetails;
